import _ from 'lodash';
import $ from 'jquery';
import angular from 'angular';
import template from './searchView.html';
import logger from '../../shared/logger';
import { RECRUITER_WORKFLOW_STATUS } from '../recruiter/constants/recruiter-workflow';
import { CONTACT_CHANNEL_TYPES, CONTACT_MODE_TYPES } from '../recruiter/constants/contactTypes';
import { ExplainInDetailsLevel } from '../core/route/talentScoreService';

String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.replace(new RegExp(search, 'g'), replacement);
};

export const TALENTS_EXPLAIN_CHUNK_SIZE = 10;

export const searchTypes = {
    LEGACY: 'LEGACY',
    CASCADING: 'CASCADING',
};

// TODO Should be refactored!!!
export class SearchController {
    isSelectAllCheckboxVisible = false;
    explainTalentsFilter = {};

    /* @ngInject */
    constructor(
        $filter,
        $localStorage,
        $location,
        $q,
        $rootScope,
        $scope,
        $sessionStorage,
        $state,
        $stateParams,
        $timeout,
        $translate,
        $uibModal,
        clipboard,
        AuthService,
        buildCSVService,
        CandidateApprovalService,
        CandidateService,
        CommonCodeService,
        ContactCandidateService,
        DOMAIN_CONFIG,
        EMPLOYER_WORKFLOW_STATUS,
        EmployerWorkflowStepResolver,
        EnvSettings,
        ERROR_EVENTS,
        LocationService,
        ModalDialogService,
        NotificationService,
        permissions,
        PositionService,
        RecruiterService,
        RecruiterWorkflowStepResolver,
        RouteService,
        searchCacheService,
        searchService,
        staticDataService,
        TalentForEmployerService,
        TalentScoreService,
        TalentService,
        utils,
        WorkflowService,
        RecruiterCandidateService,
        FeedbackFilterService,
        Logger,
        WebAppRouteService,
        EmployerRepService,
    ) {
        const searchCtrl = this;
        this.$scope = $scope;
        this.$sessionStorage = $sessionStorage;
        this.$localStorage = $localStorage;
        this.$state = $state;
        this.$stateParams = $stateParams;
        this.$timeout = $timeout;
        this.$filter = $filter;
        this.$uibModal = $uibModal;
        this.clipboard = clipboard;
        this.DOMAIN_CONFIG = DOMAIN_CONFIG;
        this.NotificationService = NotificationService;
        this.PositionService = PositionService;
        this.PermissionService = permissions;
        this.RecruiterWorkflowStepResolver = RecruiterWorkflowStepResolver;
        this.StaticDataService = staticDataService;
        this.TalentScoreService = TalentScoreService;
        this.EmployerRepService = EmployerRepService;
        this.TalentService = TalentService;
        this.utils = utils;
        this.WorkflowService = WorkflowService;
        this.WebAppRouteService = WebAppRouteService;
        this.CONTACT_MODE_TYPES = CONTACT_MODE_TYPES;
        this.CONTACT_CHANNEL_TYPES = CONTACT_CHANNEL_TYPES;

        searchCtrl.$onInit = async function () {
            if (!$localStorage.searchShowOption) {
                $localStorage.searchShowOption = {
                    showAll: false,
                    showActive: false,
                };
            }
            searchCtrl.searchShowOption = $localStorage.searchShowOption;
            searchCtrl.filteredByUser = true;
            searchCtrl._ = window._;
            $(window)
                .scrollTop(0);
            searchCtrl.canClaim = true;
            searchCtrl.loading = false;
            searchCtrl.selectAllOnCurrentPage = false;
            searchCtrl.selectAll = false;
            searchCtrl.talenyaUser = permissions.isTalenyaUser();
            searchCtrl.canSendToEmployer = searchCtrl.searchData.canSendToEmployer;
            searchCtrl.isSearchPage = searchCtrl.searchData.showView === 'MainSearch';

            // TODO: investigate why it fails if not in timeout
            $timeout(async () => {
                await searchCtrl.checkIfSearchByLookAlike();
                await searchCtrl.checkIfSearchByFeedbackAlike();
            });

            try {
                if (window.TE !== undefined && window.TE.sendMessage) {
                    searchCtrl.showLinkedinIcon = true;
                }
            } catch (e) {
                logger.warn('Error chrome extension =>', e);
                searchCtrl.showLinkedinIcon = false;
            }
            searchCtrl.filteredCandidates = {
                resultListLength: 0,
            };
            searchCtrl.searchExplainScore = $sessionStorage.searchExplainScore;
            if ($sessionStorage.savedCandidateProfile && searchCtrl.searchData.positionId !== $sessionStorage.savedCandidateProfile.positionId) {
                $sessionStorage.savedCandidateProfile = null;
            } else {
                searchCtrl.savedCandidateProfile = $sessionStorage.savedCandidateProfile;
            }

            if (searchCtrl.searchData.employerId) {
                if (searchCtrl.searchData.showView === 'MainSearch') {
                    searchCtrl.candidateUrl = `/employer/${searchCtrl.searchData.employerId}/search/position/${searchCtrl.searchData.positionId}/searchHistory/${searchCtrl.searchData.currSearchHistoryIndex}/candidatesPage/${searchCtrl.searchData.currCandidatePage}/scroll/0/candidatesName/${searchCtrl.searchData.candidatesName}/searchName/${searchCtrl.searchData.searchName}/candidate/`;
                } else {
                    searchCtrl.candidateUrl = `/employer/${searchCtrl.searchData.recruiterId}/candidatesJob/${searchCtrl.searchData.positionId}/workflowStep/${!searchCtrl.searchData.workFlowStatus
                        ? 'Prospect'
                        : searchCtrl.searchData.workFlowStatus}/candidatesPage/${searchCtrl.searchData.currCandidatePage}/scroll/0/candidate/`;
                }
            } else if (searchCtrl.searchData.recruiterId) {
                if (searchCtrl.searchData.showView === 'MainSearch') {
                    searchCtrl.candidateUrl = `/recruiter/${searchCtrl.searchData.recruiterId}/search/position/${searchCtrl.searchData.positionId}/searchHistory/${searchCtrl.searchData.currSearchHistoryIndex}/candidatesPage/${searchCtrl.searchData.currCandidatePage}/scroll/0/candidatesName/${searchCtrl.searchData.candidatesName}/searchName/${searchCtrl.searchData.searchName}/candidate/`;
                } else {
                    searchCtrl.candidateUrl = `/recruiter/${searchCtrl.searchData.recruiterId}/candidatesJob/${searchCtrl.searchData.positionId}/workflowStep/${!searchCtrl.searchData.workFlowStatus
                        ? 'Prospect'
                        : searchCtrl.searchData.workFlowStatus}/candidatesPage/${searchCtrl.searchData.currCandidatePage}/scroll/0/candidate/`;
                }
            }

            searchCtrl.summernoteOptions = {
                defaultFontName: 'Arial',
                toolbar: [
                    [
                        'style',
                        ['bold', 'italic', 'underline'],
                    ],
                    ['alignment', ['ul'],
                    ],
                    [
                        'insert',
                        ['ltr', 'rtl'],
                    ],
                ],
                callbacks: {
                    onInit(summernote) {
                        searchCtrl.summernoteInstance = summernote;
                        summernote
                            .toolbar
                            .hide();
                        const $win = $(window);
                        const $noteEditor = $('.note-editor');
                        $win.on('click.Bst', (event) => {
                            if ($noteEditor.has(event.target).length == 0 && !$noteEditor.is(event.target)) {
                                summernote
                                    .toolbar
                                    .hide();
                            }
                        });
                        summernote
                            .editable
                            .focus(() => {
                                summernote
                                    .toolbar
                                    .show();
                            });
                    },
                },
            };

            searchCtrl.previousState = $sessionStorage.previousState;
            searchCtrl.positionSearchName = $sessionStorage.positionSearchName;

            searchService
                .getUserSearches()
                .then((response = {}) => {
                    searchCtrl.userSearches = response.result || [];
                    $localStorage.userSearches = searchCtrl.userSearches;
                })
                .catch(err => logger.error(err));

            searchService
                .getUserCandidates()
                .then((response) => {
                    searchCtrl.userCandidates = response.result || [];
                    $localStorage.userCandidates = searchCtrl.userCandidates;
                })
                .catch(err => logger.error(err));

            searchCtrl.interviewStatusCurrentJob = [
                {
                    value: 'satisfied_not_looking',
                    name: 'SATISFIED_NOT_LOOKING',
                }, {
                    value: 'satisfied_but_open',
                    name: 'SATISFIED_BUT_OPEN',
                }, {
                    value: 'not_satisfied',
                    name: 'NOT_SATISFIED',
                }, {
                    value: 'no_longer_employed',
                    name: 'NO_LONGER_EMPLOYED',
                }, {
                    value: 'gave_notice',
                    name: 'GAVE_NOTICE',
                }, {
                    value: 'other',
                    name: 'OTHER',
                },
            ];

            searchCtrl.jobSeekerManualStatuses = [
                {
                    value: 'activeSeeker',
                    name: 'ACTIVE_SEEKER',
                }, {
                    value: 'nonSeeker',
                    name: 'NON_SEEKER',
                }, {
                    value: 'unknown',
                    name: 'UNKNOWN',
                }, {
                    value: 'undecided',
                    name: 'UNDECIDED',
                }, {
                    value: 'openToHear',
                    name: 'OPEN_TO_HEAR',
                },
            ];
            searchCtrl.jobSeekerManualSources = [
                {
                    value: 'campaign',
                    name: 'CAMPAIGN',
                }, {
                    value: 'web site',
                    name: 'WEB_SITE',
                }, {
                    value: 'referral',
                    name: 'REFERRAL',
                }, {
                    value: 'communication',
                    name: 'COMMUNICATION',
                },
            ];
            searchCtrl.fromMatchValues = [];

            searchCtrl.fromPredictionValues = [];

            let tempFromValues = 0;
            for (let i = 0; i <= 10; i++) {
                searchCtrl
                    .fromMatchValues
                    .push({
                        value: tempFromValues,
                        text: `${tempFromValues * 100}%`,
                    });
                searchCtrl
                    .fromPredictionValues
                    .push({
                        value: tempFromValues,
                        text: `${tempFromValues * 100}%`,
                    });

                tempFromValues = parseFloat((tempFromValues + 0.1).toFixed(1));
            }

            searchCtrl.numberOfCandidatesToSearch = RouteService.getSystemDefaults('NumberOfCandidatesToSearch');

            const minTotalRequestedSearchCandidates = 400;

            searchCtrl.searchResultTotalCountValues = [
                {
                    name: `${searchCtrl.numberOfCandidatesToSearch || minTotalRequestedSearchCandidates}`,
                    value: searchCtrl.numberOfCandidatesToSearch || minTotalRequestedSearchCandidates,
                    text: `${searchCtrl.numberOfCandidatesToSearch || minTotalRequestedSearchCandidates}`,
                },
                { name: '1000', value: 1000, text: '1000' },
                { name: '2000', value: 2000, text: '2000' },
                { name: 'All', value: RouteService.getSystemDefaults('maxTotalRequestedSearchCandidates') || 5000, text: 'All' },
            ];

            searchCtrl.showExplainSearch = false;

            searchCtrl.searchName = null;

            searchCtrl.candidatesName = null;

            searchCtrl.lastSearchField = searchCacheService.getLastSearchField();

            searchCtrl.scroll = parseInt(searchCtrl.searchData.scroll);

            searchCtrl.currentPage = parseInt(searchCtrl.searchData.currCandidatePage);

            searchCtrl.currentTalentID = searchCtrl.searchData.talentID;

            searchCtrl.currSearchHistoryIndex = parseInt(searchCtrl.searchData.currSearchHistoryIndex);

            searchCtrl.userPicture = RouteService.getUserData('picture');

            searchCtrl.maxTalentsToClaim = RouteService.getSystemDefaults('maxTalentsPerTalentExpertPosition');


            const initFilters = () => {
                const filters = [{
                    name: 'searchFromMatch',
                    values: searchCtrl.fromMatchValues,
                    defaultValue: RouteService.getSystemDefaults('searchFromMatch'),
                }, {
                    name: 'searchFromPrediction',
                    values: searchCtrl.fromPredictionValues,
                    defaultValue: RouteService.getSystemDefaults('searchFromPrediction'),
                }, {
                    name: 'searchResultTotalCount',
                    values: searchCtrl.searchResultTotalCountValues,
                    defaultValue: searchCtrl.numberOfCandidatesToSearch,
                }];

                _.forEach(filters, (filter) => {
                    if (!$sessionStorage[filter.name]) {
                        const foundMatch = _.find(filter.values, { value: filter.defaultValue });
                        if (foundMatch) {
                            $sessionStorage[filter.name] = foundMatch;
                            searchCtrl[filter.name] = foundMatch;
                        }
                    } else {
                        searchCtrl[filter.name] = $sessionStorage[filter.name];
                    }
                });
            };

            searchCtrl.searchType = $sessionStorage.searchType || searchTypes.CASCADING;
            initFilters();

            searchCtrl.candidatesPerPage = RouteService.getSystemPreference('candidatesPerPage');

            searchCtrl.searchNameFilterDelay = RouteService.getSystemPreference('searchNameFilterDelay');

            searchCtrl.talentScoreKPIs = RouteService.getSystemPreference('talentScoreKPIs');

            searchCtrl.searchCriteria = searchCacheService.getSearch(searchCtrl.currSearchHistoryIndex);

            searchCtrl.searchCriteriaFields = searchCtrl.searchCriteria.fields;
            searchCtrl.searchName = searchCtrl.searchData.searchName;

            searchCtrl.candidatesName = searchCtrl.searchData.candidatesName;

            searchCtrl.activeCriteria = null;

            searchCtrl.additionalCSVColumns = [{
                count: 1,
                type: 'value',
                columnName: 'EXPORT_LIST_MATCH_SCORE',
                key: {
                    parentKey: 'matchScore',
                },
            }];

            staticDataService.getStaticData('languages', (data) => {
                searchCtrl.lookupLanguages = data;
            });

            staticDataService.getStaticData('languagesLevel', (data) => {
                searchCtrl.proficiency = data;
            });

            if (searchCtrl.searchData.recruiterId) {
                searchCtrl.canClaim = true;
                if (!$stateParams.talentID) {
                    WorkflowService
                        .getWorkflowSearch({
                            positionId: searchCtrl.searchData.positionId,
                            recruiterId: searchCtrl.searchData.recruiterId,
                        })
                        .then((response) => {
                            let claimedTalents = 0;
                            const statusesToHide = [
                                RECRUITER_WORKFLOW_STATUS.PROSPECT,
                                RECRUITER_WORKFLOW_STATUS.REJECTED,
                                RECRUITER_WORKFLOW_STATUS.HIDDEN,
                            ];

                            for (let i = 0; i < response.result.length; i++) {
                                if (statusesToHide.indexOf(response.result[i].recruiterStatus.current) < 0) {
                                    claimedTalents++;
                                }
                                if (claimedTalents >= searchCtrl.maxTalentsToClaim) {
                                    searchCtrl.canClaim = false;
                                }
                            }
                        })
                        .catch(err => logger.error(err));
                }
            }

            $scope
                .$watch('searchCtrl.currentPage', (newPage, previousPage) => {
                    if (newPage !== previousPage) {
                        if (searchCtrl.currSearchHistoryIndex > 0) {
                            $localStorage.searchName = null;
                            if (searchCtrl.candidates && searchCtrl.candidates.resultList) {
                                for (let i = 0; i < searchCtrl.candidates.resultList.length; i++) {
                                    if (searchCtrl.candidates.resultList[i].candidateData) {
                                        delete searchCtrl.candidates.resultList[i].candidateData;
                                        delete searchCtrl.candidates.resultList[i].explainScore;
                                    }
                                }
                            }
                            searchCacheService.saveSearchResult(searchCtrl.currSearchHistoryIndex, searchCtrl.candidates);
                            $state.go($state.current.name, {
                                currCandidatePage: newPage,
                                scroll: 0,
                                alike: searchCtrl.lookAlike,
                            }, { reload: $state.current.name });
                        }
                    }
                });

            if (searchCtrl.currentPage <= 0) {
                return $state.go($state.current.name, {
                    currCandidatePage: 1,
                    alike: false,
                }, { reload: $state.current.name });
            }

            $scope
                .$watch('searchCtrl.searchCriteriaFields', (newValue, oldValue) => {
                    const oldSelectedValuesSorted = utils.getSearchValuableFieldsSorted(oldValue);
                    const newSelectedValuesSorted = utils.getSearchValuableFieldsSorted(newValue);

                    if (JSON.stringify(newSelectedValuesSorted) !== JSON.stringify(oldSelectedValuesSorted)) {
                        $localStorage.searchName = null;
                        const nextIndex = searchCacheService.addSearch({
                            name: searchCtrl.searchName,
                            fields: (newValue || []).map(criteria => ({
                                ...criteria,
                                selectedLookAlike: criteria.selected,
                                minSelectedLookAlike: criteria.minSelected,
                                maxSelectedLookAlike: criteria.maxSelected,
                            })),
                        }, searchCtrl.currSearchHistoryIndex);
                        searchCacheService.saveSearchResult(searchCtrl.currSearchHistoryIndex, null);
                        $state.go($state.current.name, {
                            currSearchHistoryIndex: nextIndex,
                            currCandidatePage: 1,
                            scroll: $(window)
                                .scrollTop(),
                            candidatesName: null,
                            alike: searchCtrl.lookAlike,
                        }, { reload: $state.current.name });
                    }
                }, true);

            if (searchCtrl.candidatesName && searchCtrl.currentTalentID == null) {
                searchService
                    .getUserCandidate(searchCtrl.candidatesName)
                    .then((response) => {
                        searchCtrl.filteredCandidates = {
                            resultList: response.result,
                            resultListLength: response.result.length,
                        };
                        searchCtrl.candidates = searchCtrl.filteredCandidates;
                        searchCtrl.getCurrentPageCandidates();
                    })
                    .catch(err => logger.error(err));
                return;
            }

            searchCtrl.candidates = searchCtrl.searchData.candidates || searchCacheService.getSearchResults(searchCtrl.currSearchHistoryIndex);

            if (searchCtrl.candidates) {
                searchCtrl.searchData.prospectsCandidates = RecruiterCandidateService.getProspectCandidates(
                    searchCtrl.candidates.resultList,
                    searchCtrl.searchShowOption.showAll,
                    searchCtrl.searchShowOption.showActive,
                ).length;

                if (searchCtrl.searchName && searchCtrl.searchName.length > 1) {
                    const reg_str = searchCtrl
                        .searchName
                        .split(/[^.\w]/)
                        .map(str => `(?=.*${str})`)
                        .join('');
                    const regex = new RegExp(`${reg_str}.+`, 'i');
                    const filteredCandidates = _.filter(searchCtrl.candidates.resultList, candidate => regex.exec(candidate.fullName));

                    searchCtrl.filteredCandidates = {
                        resultList: filteredCandidates,
                        resultListLength: filteredCandidates.length,
                    };
                } else {
                    searchCtrl.filteredCandidates = searchCtrl.candidates;
                }

                searchCtrl.candidateCheck();
                searchCtrl.getCurrentPageCandidates();
                searchCtrl.updateFilteredListOfCandidateToDisplay();

                return;
            }

            const isSearchPage = searchCtrl.searchData.showView === 'MainSearch';
            const searchRequest = searchCtrl.getSearchRequest(isSearchPage);

            if (isSearchPage && _.get(searchRequest, 'selected.length', 0) === 0) {
                return;
            }

            searchCtrl.loading = true;

            try {
                searchCtrl.searchFilter = searchRequest;

                const response = isSearchPage ?
                    await TalentScoreService.postTalentScore(searchRequest) :
                    await TalentScoreService.searchByPositionId(searchCtrl.searchData.positionId, searchRequest);

                if (response) {
                    if (response.errorCode === 'SUCCESS') {
                        if (response.result) {
                            searchCtrl.candidates = response.result;

                            searchCtrl.searchData.prospectsCandidates = RecruiterCandidateService.getProspectCandidates(
                                searchCtrl.candidates.resultList,
                                searchCtrl.searchShowOption.showAll,
                                searchCtrl.searchShowOption.showActive,
                            ).length;
                            if (searchCtrl.searchName && searchCtrl.searchName.length > 1) {
                                const reg_str = searchCtrl
                                    .searchName
                                    .split(/[^.\w]/)
                                    .map(str => `(?=.*${str})`)
                                    .join('');
                                const regex = new RegExp(`${reg_str}.+`, 'i');
                                const filteredCandidates = _.filter(searchCtrl.candidates.resultList, candidate =>
                                    regex.exec(candidate.fullName));
                                searchCtrl.filteredCandidates = {
                                    resultList: filteredCandidates,
                                    resultListLength: filteredCandidates.length,
                                };
                            } else {
                                searchCtrl.filteredCandidates = searchCtrl.candidates;
                            }
                            searchCtrl.getCurrentPageCandidates();
                        } else {
                            searchCtrl.candidates = {
                                resultListLength: 0,
                            };
                        }
                    } else {
                        searchCtrl.errorMessage = response.message;
                        searchCtrl.initScroller();
                    }
                } else {
                    logger.info('No talent score response for request => ', searchRequest);
                }
            } catch (error) {
                logger.error(error);
            } finally {
                searchCtrl.loading = false;
            }
        };

        searchCtrl.getFilteredList = (options = { skipExplains: false }) => {
            const { skipExplains } = options;
            const resultList = searchCtrl.filteredCandidates.resultList;
            const showAll = searchCtrl.searchShowOption.showAll;
            const showActive = searchCtrl.searchShowOption.showActive;
            const isProspectStep = searchCtrl.getWorkflowName() === RECRUITER_WORKFLOW_STATUS.PROSPECT;

            const filteredList = (resultList || []).filter((candidate) => {
                const isCandidateCurrentStatusHidden = _.get(candidate, 'workflow.recruiterStatus.current') === RECRUITER_WORKFLOW_STATUS.HIDDEN;
                const isCandidateCurrentStatusProspect = _.get(candidate, 'workflow.recruiterStatus.current') === RECRUITER_WORKFLOW_STATUS.PROSPECT;
                const bigPredictionScore = candidate.predictionScore >= 95.0 / 100.0;

                const isProspectCandidateToHide = isCandidateCurrentStatusProspect
                        && isProspectStep
                        && FeedbackFilterService.getCandidateFeedbackInfo(candidate).isNotFit;

                const canBeShownInAllList = !isProspectCandidateToHide && (showAll || !candidate.workflow || !isCandidateCurrentStatusHidden);
                const canBeShownInActiveList = !isProspectCandidateToHide && ((showActive && bigPredictionScore) || !showActive);

                return canBeShownInAllList && canBeShownInActiveList;
            });

            // resultListLength used for pagination, list itself should not bee affected in order for page filters to work
            searchCtrl.filteredCandidates.resultListLength = filteredList.length;

            searchCtrl.candidatesToExport = filteredList.filter(candidate => candidate.check);
            searchCtrl.talentIdsToExport = (searchCtrl.candidatesToExport || []).map(candidate => candidate.talentID);

            searchCtrl.filteredCandidatesLength = filteredList.length;
            searchCtrl.searchData.prospectsCandidates = filteredList.length;

            const slicedList = filteredList.slice(
                (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage,
                searchCtrl.currentPage * searchCtrl.candidatesPerPage,
            );

            if (!skipExplains && searchCtrl.talentsGot) {
                const talentIDs = (slicedList || []).reduce((resultIDs, candidate) => {
                    if (candidate.candidateData) {
                        resultIDs.push(candidate.talentID);
                    }

                    return resultIDs;
                }, []);

                if (talentIDs.length > 0) {
                    searchCtrl.getTalents({ talentIDs }, { isListView: true });
                }
            }

            if (searchCtrl.currentTalentID) {
                const candidateIndex = _.findIndex(filteredList, item => _.get(item, 'talentId', item.talentID) === searchCtrl.currentTalentID) % searchCtrl.candidatesPerPage;
                if (candidateIndex >= 0) {
                    searchCtrl.candidateIndex = candidateIndex;
                }
            }
            const finalList = slicedList.filter(candidate => candidate.candidateData);

            const isSourcingServicesEnabled = _.get(searchCtrl, 'searchData.positionData.employerContactCandidates');
            const { backButtonText, canClaim } = searchCtrl;

            for (const talent of finalList) {
                CommonCodeService.updateCallForActionForTalent({
                    talent,
                    isSourcingServicesEnabled,
                    backButtonText,
                    canClaim,
                });
            }

            return finalList;
        };

        searchCtrl.getContactChannelData = talentIds =>
            this.PositionService.getContactChannelData(talentIds, this.$stateParams.positionId);

        searchCtrl.refreshContactChannelData = () => {
            if (searchCtrl.$stateParams.workflowStep === RECRUITER_WORKFLOW_STATUS.PROSPECT) {
                return;
            }

            searchCtrl.getContactChannelData(_.map(searchCtrl.filteredListOfCandidatesToDisplay, 'talentID'))
                .then(({ result: talentsChannels }) => {
                    searchCtrl.filteredListOfCandidatesToDisplay.forEach((candidate) => {
                        const talentChannelData = _.find(talentsChannels, { talentId: candidate.talentID });

                        if (talentChannelData) {
                            candidate.contactChannels = talentChannelData;
                        }
                    });
                    searchCtrl.$scope.$apply();
                });
        };

        searchCtrl.updateFilteredListOfCandidateToDisplay = (options = { skipExplains: false }) => {
            searchCtrl.filteredListOfCandidatesToDisplay = searchCtrl.getFilteredList(options);
            searchCtrl.isSelectAllCheckboxVisible = searchCtrl.filteredListOfCandidatesToDisplay.length > 0;
            searchCtrl.isExportCsvVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkExportCSVIsAvailable();
            searchCtrl.isBulkClaimVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkBulkClaimIsAvailable();

            searchCtrl.refreshContactChannelData();
        };

        searchCtrl.updatePageFilters = ({
            showAll = searchCtrl.searchShowOption.showAll,
            showActive = searchCtrl.searchShowOption.showActive,
        }) => {
            searchCtrl.searchShowOption.showAll = showAll;
            searchCtrl.searchShowOption.showActive = showActive;
            searchCtrl.updateFilteredListOfCandidateToDisplay();
        };

        searchCtrl.initScroller = function () {
            if ($localStorage.scroll && !searchCtrl.searchData.talentID) {
                $timeout(() => {
                    $(window)
                        .scrollTop(parseInt($localStorage.scroll));
                    $localStorage.scroll = null;
                }, 200);
            } else if (searchCtrl.scroll) {
                $timeout(() => {
                    $(window)
                        .scrollTop(searchCtrl.scroll);
                    searchCtrl.scroll = null;
                }, 200);
            } else {
                $(window)
                    .scrollTop(0);
            }
        };

        searchCtrl.getCurrentPageCandidates = async function () {
            if (!searchCtrl.filteredCandidates) {
                searchCtrl.loading = false;
                searchCtrl.showCandidate = false;

                return;
            }

            const deffered = $q.defer();

            if (!searchCtrl.searchData.candidates) {
                try {
                    const { result: allWorkflows } = await WorkflowService.getWorkflowSearch({
                        positionId: searchCtrl.searchData.positionId,
                        talentId: {
                            $in: _.map(searchCtrl.filteredCandidates.resultList, 'talentID'),
                        },
                    });

                    if (searchCtrl.searchData.recruiterId) {
                        let claimedInOtherPositionByOtherRecruiter = 0;

                        let isNotOwnJobAndNotProspectHiddenOrRejectedReason = 0;
                        let isAnotherRecruiterAndNotProspectOrHiddenReason = 0;
                        let isSamePositionAndCustomSearchAndNotProspectOrHiddenReason = 0;

                        Logger.info({
                            allWorkflows,
                            candidatesCount: searchCtrl.filteredCandidates.resultList.length,
                        });

                        for (const workflow of allWorkflows) {
                            const isAnotherRecruiter = false;
                            const isAnotherPosition = searchCtrl.searchData.positionId !== workflow.positionId;
                            const isCustomSearch = searchCtrl.searchData.showView === 'customSearch';
                            const isNotProspectOrHidden = ['Prospect', 'Hidden'].indexOf(workflow.recruiterStatus.current) < 0;
                            const isNotProspectHiddenOrRejected = ['Rejected', 'Prospect', 'Hidden'].indexOf(workflow.recruiterStatus.current) < 0;

                            const isOwnJobAndNotCustomSearch =
                                !isAnotherRecruiter
                                && !isAnotherPosition
                                && !isCustomSearch;
                            const isOwnJobAndNotProspectOrHiddenAndCustomSearch =
                                !isAnotherRecruiter
                                && !isAnotherPosition
                                && !isNotProspectOrHidden
                                && isCustomSearch;
                            const isNotOwnJob =
                                isAnotherRecruiter
                                && isAnotherPosition;
                            const isNotOwnJobAndNotProspectHiddenOrRejected =
                                isNotOwnJob
                                && isNotProspectHiddenOrRejected;
                            const isAnotherRecruiterAndNotProspectOrHidden =
                                isAnotherRecruiter
                                && isNotProspectOrHidden;
                            const isSamePositionAndCustomSearchAndNotProspectOrHidden =
                                !isAnotherPosition
                                && isCustomSearch
                                && isNotProspectOrHidden;
                            const isNeedToRemoveWorkflowFromList =
                                isNotOwnJobAndNotProspectHiddenOrRejected
                                || isAnotherRecruiterAndNotProspectOrHidden
                                || isSamePositionAndCustomSearchAndNotProspectOrHidden;
                            const isValidWorkflowToAdd =
                                isOwnJobAndNotCustomSearch
                                || isOwnJobAndNotProspectOrHiddenAndCustomSearch;

                            if (isNotOwnJob) {
                                claimedInOtherPositionByOtherRecruiter++;
                            }

                            if (isNeedToRemoveWorkflowFromList) {
                                const removedTalents = _.remove(searchCtrl.filteredCandidates.resultList, { talentID: workflow.talentId });

                                if (removedTalents.length) {
                                    isNotOwnJobAndNotProspectHiddenOrRejected
                                    && isNotOwnJobAndNotProspectHiddenOrRejectedReason++;
                                    isAnotherRecruiterAndNotProspectOrHidden
                                    && isAnotherRecruiterAndNotProspectOrHiddenReason++;
                                    isSamePositionAndCustomSearchAndNotProspectOrHidden
                                    && isSamePositionAndCustomSearchAndNotProspectOrHiddenReason++;
                                }
                            }

                            if (isValidWorkflowToAdd) {
                                const candidate = _.find(searchCtrl.filteredCandidates.resultList, { talentID: workflow.talentId });

                                if (candidate) {
                                    candidate.workflow = workflow;
                                    candidate.workflow.feedback = RecruiterCandidateService.getCandidateFeedback(
                                        candidate,
                                        workflow,
                                        searchCtrl.searchData.positionData,
                                    );
                                }
                            }
                        }

                        Logger.info({
                            isNotOwnJobAndNotProspectHiddenOrRejectedReason,
                            isAnotherRecruiterAndNotProspectOrHiddenReason,
                            isSamePositionAndCustomSearchAndNotProspectOrHiddenReason,
                        });

                        const hasClaimedByOtherAndRefreshSearchAndParamsNotClaimedByOtherTe =
                            claimedInOtherPositionByOtherRecruiter > 0 &&
                            searchCtrl.searchData.refreshSearch &&
                            $stateParams.claimedByOtherTE == null;

                        if (hasClaimedByOtherAndRefreshSearchAndParamsNotClaimedByOtherTe) {
                            searchCtrl
                                .searchData
                                .refreshSearch(claimedInOtherPositionByOtherRecruiter);
                        }
                        searchCtrl.filteredCandidates.resultListLength = searchCtrl.filteredCandidates.resultList.length;
                    } else {
                        const currentPositionWorkflows = allWorkflows.filter(workflow => searchCtrl.searchData.positionId === workflow.positionId);
                        for (const workflow of currentPositionWorkflows) {
                            const candidate = _.find(searchCtrl.filteredCandidates.resultList, { talentID: workflow.talentId });

                            if (candidate) {
                                candidate.workflow = workflow;
                                candidate.workflow.feedback = RecruiterCandidateService.getCandidateFeedback(
                                    candidate,
                                    workflow,
                                    searchCtrl.searchData.positionData,
                                );
                            }
                        }
                        searchCtrl.filteredCandidates.resultListLength = searchCtrl.filteredCandidates.resultList.length;
                    }
                } catch (error) {
                    logger.error(error);
                }

                if (searchCtrl.searchData.showView === 'MainSearch') {
                    const candidatesToFetchRecruiter = _.filter(searchCtrl.filteredCandidates.resultList, (({ workflow }) => _.get(workflow, 'recruiterId', false)));

                    if (candidatesToFetchRecruiter.length) {
                        const recruitersToFetchIds = _(candidatesToFetchRecruiter)
                            .map(({ workflow }) => workflow.recruiterId)
                            .uniq()
                            .value();

                        const { result: recruiters } = await RecruiterService.postRecruiterSearch({ recruiterIDs: recruitersToFetchIds });
                        const recruitersById = _.keyBy(recruiters, '_id');

                        _.forEach(candidatesToFetchRecruiter, (candidate) => {
                            const recruiterId = _.get(candidate, 'workflow.recruiterId', null);
                            if (recruitersById[recruiterId]) {
                                candidate.recruiter = recruitersById[recruiterId];
                            }
                        });
                    }
                }
            }

            deffered.resolve(true);

            deffered
                .promise
                .then(async () => {
                    searchCtrl.searchData.prospectsCandidates = RecruiterCandidateService.getProspectCandidates(
                        searchCtrl.candidates.resultList,
                        searchCtrl.searchShowOption.showAll,
                        searchCtrl.searchShowOption.showActive,
                    ).length;
                    const candidates = { talentIDs: [] };
                    let index = 0;
                    let openCandidateFound = false;

                    const isSamplesTab = searchCtrl.$stateParams.workflowStep === 'Samples';
                    const isFeedbackTab = searchCtrl.$stateParams.workflowStep === 'Feedback';
                    const isProspectTab = searchCtrl.$stateParams.workflowStep === 'Prospect';

                    if (isSamplesTab) {
                        const sampleIndex = _.findIndex(searchCtrl.searchData.manuallyAddedSamples, {
                            talentID: searchCtrl.currentTalentID,
                        });

                        if (sampleIndex >= 0) {
                            searchCtrl.filteredCandidates.resultList = searchCtrl.searchData.manuallyAddedSamples;
                            searchCtrl.filteredCandidates.resultListLength = searchCtrl.searchData.manuallyAddedSamples.length;
                            searchCtrl.openShowCandidate(searchCtrl.searchData.manuallyAddedSamples[sampleIndex]);
                            searchCtrl.candidateIndex = sampleIndex;
                            searchCtrl.loading = false;
                            searchCtrl.initScroller();
                            searchCtrl.talentsGot = true;

                            return;
                        }
                    }

                    if (isFeedbackTab) {
                        let candidateList = searchCtrl.searchData.workflowData.requestFeedback.added.resultList;
                        let candidateIndex = _.findIndex(candidateList, { talentId: searchCtrl.currentTalentID });
                        let candidateToOpen = candidateList[candidateIndex];

                        if (!candidateToOpen.candidateData) {
                            const { feedbackFilterState, feedbackListPageOptions } = searchCtrl.searchData;
                            const pageToFetch = Math.floor(candidateIndex / feedbackListPageOptions.size);
                            const pageOptions = { ...feedbackListPageOptions, page: pageToFetch };

                            await searchCtrl.searchData.fetchFeedbackCandidatesMore(pageOptions, feedbackFilterState);

                            candidateList = searchCtrl.searchData.workflowData.requestFeedback.added.resultList;
                            candidateIndex = _.findIndex(candidateList, { talentId: searchCtrl.currentTalentID });
                            candidateToOpen = candidateList[candidateIndex];
                        }

                        if (candidateIndex >= 0) {
                            searchCtrl.openShowCandidate(candidateToOpen);
                            searchCtrl.candidateIndex = candidateIndex;
                            searchCtrl.loading = false;
                            searchCtrl.initScroller();
                            searchCtrl.talentsGot = true;

                            if (searchCtrl.searchData.getNotes) {
                                searchCtrl.searchData.getNotes(candidateToOpen);
                            }

                            return;
                        }
                    }

                    if (!isProspectTab) {
                        const candidateList = searchCtrl.searchData.candidates;
                        const candidateIndex = _.findIndex(candidateList, { talentId: searchCtrl.currentTalentID });

                        if (candidateIndex >= 0) {
                            const candidateToOpen = candidateList[candidateIndex];

                            searchCtrl.openShowCandidate(candidateToOpen);
                            searchCtrl.candidateIndex = candidateIndex;
                            searchCtrl.loading = false;
                            searchCtrl.initScroller();
                            searchCtrl.talentsGot = true;

                            return;
                        }
                    }

                    for (const candidateItem of searchCtrl.filteredCandidates.resultList) {
                        const isValidCandidate = candidateItem && !candidateItem.candidateData;
                        if (isValidCandidate) {
                            candidates.talentIDs.push(candidateItem.talentID);
                        } else {
                            const condition = candidateItem &&
                                searchCtrl.currentTalentID &&
                                candidateItem.talentID === searchCtrl.currentTalentID;

                            if (condition) {
                                searchCtrl.openShowCandidate(candidateItem);
                                openCandidateFound = true;

                                if (searchCtrl.searchData.getNotes) {
                                    searchCtrl.searchData.getNotes(candidateItem);
                                }

                                searchCtrl.candidateIndex = index;
                            }
                        }

                        index++;
                    }

                    if (!openCandidateFound && searchCtrl.currentTalentID) {
                        const talentIndex = _.findIndex(searchCtrl.candidates.resultList, { talentID: searchCtrl.currentTalentID });

                        if (talentIndex >= 0) {
                            const newPage = Math.floor(talentIndex / searchCtrl.candidatesPerPage);

                            if (searchCtrl.currentPage === newPage + 1) {
                                if (!searchCtrl.candidateIndex) {
                                    searchCtrl.candidateIndex = talentIndex % searchCtrl.candidatesPerPage;
                                }

                                searchCtrl.getTalents({
                                    talentIDs: [searchCtrl.currentTalentID],
                                });

                                return;
                            }

                            $state.go($state.current.name, { currCandidatePage: newPage + 1 }, { reload: $state.current.name });

                            return;
                        }

                        $state.go($state.current.name, { talentID: null }, { reload: $state.current.name });

                        return;
                    }

                    if (!openCandidateFound) {
                        searchCtrl.showCandidate = false;
                    } else {
                        searchCtrl.loading = false;
                        searchCtrl.initScroller();
                        searchCtrl.talentsGot = true;

                        return;
                    }

                    if (candidates.talentIDs.length === 0) {
                        searchCtrl.loading = false;
                        searchCtrl.initScroller();
                        CommonCodeService.updateCallForActionForTalents(searchCtrl);
                        searchCtrl.talentsGot = true;

                        return;
                    }

                    searchCtrl.getTalents(candidates, { isListView: true });
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.getTalents = async function (talents, { isListView } = { isListView: false }) {
            const explainTalents = angular.copy(talents);

            searchCtrl.talentsGot = false;

            searchCtrl.getSelectedAndFeedbackAndManuallyAddedSamples();

            try {
                const postTalentsResponse = await TalentService.postTalents({ ...talents, isListView });

                if (postTalentsResponse && postTalentsResponse.errorCode === 'SUCCESS') {
                    const talentResults = postTalentsResponse.result;

                    for (const talentItem of talentResults) {
                        const candidate = _.find(searchCtrl.filteredCandidates.resultList, { talentID: talentItem.talentId });

                        if (candidate) {
                            talents.talentIDs.splice(talents.talentIDs.indexOf(talentItem.talentId), 1);

                            if (candidate.workflow && candidate.workflow.candidateId) {
                                candidate.feedback = RecruiterCandidateService.getCandidateFeedback(
                                    candidate,
                                    candidate.workflow,
                                    searchCtrl.searchData.positionData,
                                );
                                candidate.workflow.feedback = candidate.feedback;
                            }

                            candidate.candidateData = talentItem;
                            candidate.candidateData.matchScore = candidate.matchScore;
                            candidate.currentJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: true });
                            candidate.previousJob = _.find(candidate.candidateData.employmentHistory, { isCurrent: false });
                            candidate.residency = CommonCodeService.getLocationString(candidate.candidateData.residency);

                            if (searchCtrl.currentTalentID && candidate.talentID === searchCtrl.currentTalentID) {
                                searchCtrl.openShowCandidate(candidate);
                            }
                        }
                    }

                    CommonCodeService.updateCallForActionForTalents(searchCtrl);

                    for (const talentIdToRemove of talents.talentIDs) {
                        _.remove(searchCtrl.filteredCandidates.resultList, { talentID: talentIdToRemove });
                    }

                    const candidatesSearchResponse = await CandidateService.postCandidateSearch({
                        talentId: _.map(searchCtrl.filteredCandidates.resultList, 'talentID'),
                    });

                    for (const candidateItem of candidatesSearchResponse.result) {
                        const candidate = _.find(searchCtrl.filteredCandidates.resultList, {
                            talentID: candidateItem.talentId,
                        });

                        if (candidate && candidate.workflow) {
                            candidate.feedback = RecruiterCandidateService.getCandidateFeedback(
                                candidate,
                                candidate.workflow,
                                searchCtrl.searchData.positionData,
                            );
                            candidate.workflow.feedback = candidate.feedback;
                        }
                    }

                    const cascadingSearch = _.get(searchCtrl, 'searchType', searchTypes.LEGACY) === searchTypes.CASCADING || !searchCtrl.isSearchPage;
                    const searchRequest = {
                        searchCountries: [
                            '1234',
                            '9876',
                            '5555',
                        ].map(item => ({ code: item })),
                        searchLanguages: [{ code: '1234' }],
                        maxItems: searchCtrl.searchData.showResults || searchCtrl.numberOfCandidatesToSearch || 400,
                        cascadingSearch,
                        selected: [],
                    };

                    const removeRequiredPropertyFromItems = _.partial(_.omit, _, ['required']);
                    const removeItemsPriorityInGroups = _.partial(_.map, _, (selectedItem) => {
                        if (_.has(selectedItem, 'group')) {
                            const newGroup = _.map(selectedItem.group, removeRequiredPropertyFromItems);
                            return {
                                ...selectedItem,
                                group: newGroup,
                            };
                        }
                        return selectedItem;
                    });

                    for (let i = 0; i < searchCtrl.searchCriteriaFields.length; i++) {
                        const searchCriteriaField = searchCtrl.searchCriteriaFields[i];

                        let lookAlikFilter = searchCriteriaField.selectedLookAlike ||
                            searchCriteriaField.minSelectedLookAlike ||
                            searchCriteriaField.maxSelectedLookAlike;


                        if (searchCriteriaField.selectedLookAlike && searchCriteriaField.selectedLookAlike.length > 0) {
                            const itemsWithFilteredProperties = _.map(searchCriteriaField.selectedLookAlike, (field) => {
                                delete field.checked;
                                delete field.sourceId;
                                return field;
                            });

                            const newSelected = {
                                field: searchCriteriaField.field,
                                items: removeItemsPriorityInGroups(itemsWithFilteredProperties),
                            };
                            searchRequest
                                .selected
                                .push(newSelected);
                            lookAlikFilter = true;
                        }

                        if (searchCriteriaField.minSelectedLookAlike && searchCriteriaField.minSelectedLookAlike.length > 0) {
                            const newSelected = {
                                field: searchCriteriaField.minField,
                                items: _.map(searchCriteriaField.minSelectedLookAlike, (field) => {
                                    delete field.checked;
                                    delete field.sourceId;
                                    return field;
                                }),
                            };
                            searchRequest
                                .selected
                                .push(newSelected);
                            lookAlikFilter = true;
                        }
                        if (searchCriteriaField.maxSelectedLookAlike && searchCriteriaField.maxSelectedLookAlike.length > 0) {
                            const newSelected = {
                                field: searchCriteriaField.maxField,
                                items: _.map(searchCriteriaField.maxSelectedLookAlike, (field) => {
                                    delete field.checked;
                                    delete field.sourceId;
                                    return field;
                                }),
                            };
                            searchRequest.selected.push(newSelected);
                            lookAlikFilter = true;
                        }
                        if (lookAlikFilter) {
                            continue;
                        }
                        if (searchCriteriaField.selected && searchCriteriaField.selected.length > 0) {
                            const newSelected = {
                                field: searchCriteriaField.field,
                                items: removeItemsPriorityInGroups(searchCriteriaField.selected),
                            };
                            searchRequest.selected.push(newSelected);
                            continue;
                        }
                        if (searchCriteriaField.minSelected && searchCriteriaField.minSelected.length > 0) {
                            const newSelected = {
                                field: searchCriteriaField.minField,
                                items: searchCriteriaField.minSelected,
                            };
                            searchRequest.selected.push(newSelected);
                        }
                        if (searchCriteriaField.maxSelected && searchCriteriaField.maxSelected.length > 0) {
                            const newSelected = {
                                field: searchCriteriaField.maxField,
                                items: searchCriteriaField.maxSelected,
                            };
                            searchRequest.selected.push(newSelected);
                        }
                    }

                    explainTalents.filter = searchRequest;
                    searchCtrl.explainTalentsFilter = searchRequest;
                }

                searchCtrl.errorMessage = _.get(postTalentsResponse, 'message', null);

                searchCtrl.initScroller();
                searchCtrl.loading = false;
                searchCtrl.$scope.$apply();
            } catch (error) {
                logger.error(error);
            } finally {
                searchCtrl.updateFilteredListOfCandidateToDisplay();
                const talentIDs = _.map(searchCtrl.filteredListOfCandidatesToDisplay, 'talentID');
                const isProfileView = searchCtrl.currentTalentID;
                const filterWithExplainInDetailsLevel = {
                    ...explainTalents.filter,
                    explainInDetails: isProfileView ? ExplainInDetailsLevel.full : ExplainInDetailsLevel.minimalWithSkills,
                };
                searchCtrl.populateCandidatesWithExplain(talentIDs, filterWithExplainInDetailsLevel);
                searchCtrl.$scope.$apply();
            }
        };

        searchCtrl.getSelectedAndFeedbackAndManuallyAddedSamples = async () => {
            try {
                const positionId = _.get(searchCtrl, 'searchData.positionData._id', null);
                let allSamples = [];

                if (positionId) {
                    allSamples = await PositionService.getSelectedAndFeedbackAndManuallyAddedSamples(positionId);
                }

                const unselectedSamples = (allSamples || []).filter(({ selected }) => !selected);

                for (const sample of unselectedSamples) {
                    const candidate = _.find(searchCtrl.filteredCandidates.resultList, { talentID: sample.talentId });

                    if (candidate) {
                        candidate.sample = (allSamples || []).find(({ talentId }) => talentId === sample.talentId);
                        candidate.unselectedSample = unselectedSamples.find(({ talentId }) => talentId === sample.talentId);
                    }
                }
            } catch (error) {
                logger.error(error);
            }
        };

        searchCtrl.populateCandidatesWithExplain = async (talentIDs, filter) => {
            searchCtrl.filteredCandidates.resultList.forEach(
                candidate => talentIDs.includes(candidate.talentID) && (candidate.isExplainLoading = true),
            );

            const chunkedTalentIds = _.chunk(talentIDs, TALENTS_EXPLAIN_CHUNK_SIZE);
            const promises = [];

            const filterWithDetailsLevel = {
                ...filter,
                explainInDetails: filter.explainInDetails || ExplainInDetailsLevel.minimalWithSkills,
            };

            for (const oneChunk of chunkedTalentIds) {
                promises.push(TalentScoreService.postTalentExplainScore({ talentIDs: oneChunk, filter: filterWithDetailsLevel })
                    .then((response) => {
                        const talentExplains = _.get(response, 'result', []);

                        searchCtrl.filteredCandidates.resultList = CandidateService.addExplainsDataToCandidates({
                            candidates: searchCtrl.filteredCandidates.resultList,
                            talentExplains,
                        });

                        searchCtrl.filteredCandidates.resultList.forEach(
                            candidate => oneChunk.includes(candidate.talentID) && (candidate.isExplainLoading = false),
                        );
                    }));
            }

            await Promise.all(promises);

            searchCtrl.filteredCandidates.resultList.forEach(candidate => !candidate.isExplainLoading && (candidate.isExplainLoading = false));
            searchCtrl.updateFilteredListOfCandidateToDisplay();
            searchCtrl.$scope.$apply();
        };

        searchCtrl.openCandidate = function (candidate) {
            candidate.scroll = $(window)
                .scrollTop();
            $localStorage.scroll = candidate.scroll;
            let searchName = null;
            if (searchCtrl.searchName && searchCtrl.searchName.length > 0) {
                searchName = searchCtrl.searchName;
            }
            $state.go($state.current.name, {
                scroll: candidate.scroll,
                searchName,
            }, { notify: false });
            searchCacheService.saveSearchResult(searchCtrl.currSearchHistoryIndex, searchCtrl.candidates);
            return $timeout(() => {
                $state.go($state.current.name, {
                    talentID: candidate.talentID,
                    scroll: 0,
                    searchName,
                }, { reload: $state.current.name });
            }, 200);
        };

        searchCtrl.openShowCandidate = async function (candidate) {
            const isProspectPage = searchCtrl.$stateParams.workflowStep !== RECRUITER_WORKFLOW_STATUS.PROSPECT;

            if ($sessionStorage.candidateTab) {
                searchCtrl.candidateTab = $sessionStorage.candidateTab;
                $sessionStorage.candidateTab = null;
            } else {
                searchCtrl.candidateTab = 'profile';
            }

            const currentCandidate = candidate;
            searchCtrl.currentCandidate = currentCandidate;

            const isCandidateExists = currentCandidate.workflow && currentCandidate.workflow.candidateId && searchCtrl.searchData.recruiterId;

            if (isCandidateExists) {
                if (this.isPositionGdprCompliant) {
                    const { result: { revealPersonalData } } = await WorkflowService.getCandidateConsent(candidate.workflow._id);
                    searchCtrl.isCandidateConsentsRequired = this.isPositionGdprCompliant && !revealPersonalData;
                }
                await searchCtrl.setupCandidateSampleActions(candidate);
                const event = _.find(currentCandidate.workflow.events, (event) => {
                    if ([
                        WorkflowService.eventTypes.RESUME_CREATED,
                        'pendingApproval',
                        'approved',
                    ].indexOf(event.eventType) >= 0) {
                        searchCtrl.hasProfileForSubmition = true;

                        return true;
                    }

                    return false;
                });

                const getEventsByWorkflowId = async id => WorkflowService
                    .getEventsWorkflow(id)
                    .then(({ result }) => result)
                    .catch(err => logger.error(err));

                const getCandidateInterviews = async candidateId => CandidateService
                    .postCandidateInterviewsSearch(candidateId, {})
                    .then(({ result }) => result)
                    .catch(err => logger.error(err));

                const getInterviewForEmployer = interviews => _.remove(interviews, interview => !!(interview.employerRepId &&
                    searchCtrl.searchData.positionId === interview.positionId &&
                    searchCtrl.searchData.recruiterId === interview.recruiterId));

                const getTalentRecord = async (workflowEvent) => {
                    if (!workflowEvent) {
                        return Promise.resolve(null);
                    }
                    return TalentForEmployerService
                        .getTalentForEmployer(event.entityId)
                        .then(({ result }) => {
                            const candidateData = result;
                            return {
                                candidateData,
                                currentJob: _.find(candidateData.employmentHistory, 'isCurrent'),
                                residency: CommonCodeService.getLocationString(candidateData.residency),
                            };
                        })
                        .catch(err => logger.error(err));
                };

                const [
                    talentRecord,
                    contactChannelData,
                    events,
                    candidateInterviews,
                ] = await Promise.all([
                    getTalentRecord(event),
                    !isProspectPage ? searchCtrl.getContactChannelData([currentCandidate.workflow.talentId]) : Promise.resolve(),
                    getEventsByWorkflowId(currentCandidate.workflow._id),
                    getCandidateInterviews(currentCandidate.workflow.candidateId),
                ]);

                if (!isProspectPage) {
                    const contactChannels = _.get(contactChannelData, 'result.0', null);

                    if (talentRecord && contactChannels) {
                        talentRecord.contactChannels = contactChannels;
                    }
                }

                if (talentRecord) {
                    searchCtrl.talentRecord = talentRecord;
                }

                currentCandidate.events = events;

                currentCandidate.interviewForEmployer = getInterviewForEmployer(candidateInterviews);
                currentCandidate.interviews = _.sortBy(candidateInterviews, 'created');

                searchCtrl.interviewForEmployer = _.last(currentCandidate.interviewForEmployer);
                searchCtrl.currentInterview = _.last(currentCandidate.interviews);
                searchCtrl.currentCandidate = currentCandidate;

                searchCtrl.getRecruiterData();
                this.$scope.$evalAsync();
            }

            if (searchCtrl.searchData.employerId && searchCtrl.currentCandidate.workflow && searchCtrl.currentCandidate.workflow.candidateId) {
                CandidateService
                    .postCandidateInterviewsSearch(searchCtrl.currentCandidate.workflow.candidateId, {
                        employerRepId: searchCtrl.searchData.employerId,
                        positionId: searchCtrl.searchData.positionId,
                    })
                    .then((response) => {
                        const isInterviewExists = _.get(response, 'result.length');
                        if (isInterviewExists) {
                            searchCtrl.interviewForEmployer = response.result[0];
                        }
                    })
                    .catch(err => logger.error(err));
            }
            const currentRecruiterStatus = _.get(searchCtrl, 'currentCandidate.workflow.recruiterStatus.current');
            if (currentRecruiterStatus === 'Engaged') {
                const engagedStep = WorkflowService.getCandidateWorkflowEngagedStep(searchCtrl.currentCandidate.workflow);
                searchCtrl.engagedStep = searchCtrl.currentCandidate.workflow.engagedStep = engagedStep;
            }

            searchCtrl.showCandidate = true;
        };

        searchCtrl.openCandidates = function () {
            let scroll = 0;
            if (searchCtrl.currentCandidate.scroll) {
                scroll = searchCtrl.currentCandidate.scroll;
            }
            return $state.go($state.current.name, {
                talentID: null,
                feedbackFilterMode: null,
                scroll,
            }, { reload: $state.current.name });
        };

        searchCtrl.previousCandidate = function (currentCandidateIndex) {
            if (searchCtrl.candidateIndex == 0 || currentCandidateIndex == 0) {
                return;
            }

            const currentCandidate = searchCtrl.filteredCandidates.resultList[
                (currentCandidateIndex || searchCtrl.candidateIndex) - 1 + searchCtrl.candidatesPerPage * (searchCtrl.currentPage - 1)
            ];

            const recruiterStatus = _.get(currentCandidate, 'workflow.recruiterStatus.current');

            if (searchCtrl.searchData.showView === 'customSearch' && !searchCtrl.searchShowOption.showAll && recruiterStatus === 'Hidden') {
                return searchCtrl.previousCandidate((currentCandidateIndex || searchCtrl.candidateIndex) - 1);
            }

            searchCtrl.candidateIndex = (currentCandidateIndex || searchCtrl.candidateIndex) - 1;

            searchCtrl.currentCandidate = searchCtrl.filteredCandidates.resultList[
                searchCtrl.candidateIndex + searchCtrl.candidatesPerPage * (searchCtrl.currentPage - 1)
            ];
            if (searchCtrl.currentCandidate) {
                return $state.go($state.current.name, {
                    talentID: searchCtrl.currentCandidate.talentID,
                    scroll: 0,
                }, { reload: $state.current.name });
            }
        };

        searchCtrl.nextCandidate = async function (otherButton, { stayOnLast } = {}) {
            const isLastCandidateOnCurrentPage = searchCtrl.candidateIndex === searchCtrl.candidatesPerPage - 1;
            const isLastCandidateInList =
                (searchCtrl.candidateIndex + searchCtrl.candidatesPerPage * (searchCtrl.currentPage - 1)) ===
                searchCtrl.filteredCandidates.resultListLength - 1;
            const isOneCandidate = searchCtrl.filteredCandidates.resultListLength === 1;
            const isLast = isLastCandidateOnCurrentPage || isLastCandidateInList;

            if (isLast && otherButton) {
                if (stayOnLast) {
                    return $state.go($state.current.name, {}, { reload: true });
                }

                let pagesNumber = Math.floor(searchCtrl.filteredCandidates.resultListLength / searchCtrl.candidatesPerPage);
                const pagesOverflow = searchCtrl.filteredCandidates.resultListLength % searchCtrl.candidatesPerPage;
                if (pagesOverflow > 0) {
                    pagesNumber++;
                }

                if (pagesNumber === searchCtrl.currentPage) {
                    try {
                        const { recruiterId, positionId } = $stateParams;
                        const { employerId } = searchCtrl.searchData;
                        let workflowStep = $stateParams.workflowStep;

                        if (isOneCandidate) {
                            if (employerId) {
                                workflowStep = await EmployerWorkflowStepResolver.getWorkflowStep(positionId, employerId);
                            } else if (recruiterId) {
                                workflowStep = await RecruiterWorkflowStepResolver.getWorkflowStep(positionId, recruiterId);
                            }
                        }

                        return $state.go($state.current.name, {
                            currCandidatePage: 1,
                            scroll: 0,
                            talentID: null,
                            feedbackFilterMode: null,
                            workflowStep,
                        }, { reload: $state.current.name });
                    } catch (error) {
                        logger.error(error);

                        return;
                    }
                }

                return $state.go($state.current.name, {
                    currCandidatePage: searchCtrl.currentPage + 1,
                    scroll: 0,
                    talentID: null,
                    feedbackFilterMode: null,
                }, { reload: $state.current.name });
            } else if (isLast) {
                return;
            }
            searchCtrl.candidateIndex += 1;
            searchCtrl.currentCandidate =
                searchCtrl.filteredCandidates.resultList[searchCtrl.candidateIndex + searchCtrl.candidatesPerPage * (searchCtrl.currentPage - 1)];
            if (searchCtrl.currentCandidate) {
                return $state.go($state.current.name, {
                    talentID: searchCtrl.currentCandidate.talentID,
                    scroll: 0,
                }, { reload: $state.current.name });
            }
        };

        searchCtrl.goToNextCandidateOrNextStep = async ({ nextStep }) => {
            const candidateIntexInWholeList = searchCtrl.candidateIndex + searchCtrl.candidatesPerPage * (searchCtrl.currentPage - 1);
            const isLastCandidateOnCurrentPage = searchCtrl.candidateIndex === searchCtrl.candidatesPerPage - 1;

            const isLastCandidateInList = candidateIntexInWholeList === searchCtrl.filteredCandidates.resultListLength - 1;
            const isTheOnlyOneCandidate = searchCtrl.filteredCandidates.resultListLength === 1;
            const isLast = isLastCandidateOnCurrentPage || isLastCandidateInList;

            if (isLast) {
                let pagesNumber = Math.floor(searchCtrl.filteredCandidates.resultListLength / searchCtrl.candidatesPerPage);
                const pagesOverflow = searchCtrl.filteredCandidates.resultListLength % searchCtrl.candidatesPerPage;
                if (pagesOverflow > 0) {
                    pagesNumber++;
                }

                if (searchCtrl.currentPage === pagesNumber) {
                    try {
                        const workflowStep = isTheOnlyOneCandidate ? nextStep : $stateParams.workflowStep;

                        return $state.go($state.current.name, {
                            currCandidatePage: 1,
                            scroll: 0,
                            talentID: null,
                            feedbackFilterMode: null,
                            workflowStep,
                        }, { reload: $state.current.name });
                    } catch (error) {
                        logger.error(error);
                        return;
                    }
                }

                return $state.go($state.current.name, {
                    currCandidatePage: searchCtrl.currentPage + 1,
                    scroll: 0,
                    talentID: null,
                    feedbackFilterMode: null,
                }, { reload: $state.current.name });
            }

            searchCtrl.candidateIndex += 1;
            searchCtrl.currentCandidate =
                searchCtrl.filteredCandidates.resultList[candidateIntexInWholeList + 1];
            if (searchCtrl.currentCandidate) {
                return $state.go($state.current.name, {
                    talentID: searchCtrl.currentCandidate.talentID,
                    scroll: 0,
                }, { reload: $state.current.name });
            }
        };

        searchCtrl.createExcelFile = function () {
            return buildCSVService.createCsvFile(searchCtrl.filteredCandidates, searchCtrl.currentPage, searchCtrl.candidatesPerPage);
        };

        searchCtrl.getCsvHeaders = function () {
            return buildCSVService.getCsvHeaders();
        };

        searchCtrl.printCandidates = function (className) {
            const printContents = document.getElementsByClassName(className)[0].innerHTML;

            const popupWin = window.open('', '_blank', 'width=1000,height=1000');
            popupWin
                .document
                .open();
            popupWin
                .document
                .write(`<html><head><link rel="stylesheet" type="text/css" href="${$location.$$protocol}://${$location.$$host}:${$location.$$port}/assets/css/bootstrap.min.css" /><link rel="stylesheet" type="text/css" href="${$location.$$protocol}://${$location.$$host}:${$location.$$port}/assets/css/bootstrap-datepicker3.standalone.min.css" /><link rel="stylesheet" t` +
                    `ype="text/css" href="${$location.$$protocol}://${$location.$$host}:${$location.$$port}/assets/css/Style.css" /><link rel="stylesheet" type="text/css" href="${$location.$$protocol}://${$location.$$host}:${$location.$$port}/assets/css/custom.css" /></head><body onload="window.print()">${printContents}</body></html>`);
            popupWin
                .document
                .close();
        };

        searchCtrl.removeUserSearch = function (index) {
            searchService.deleteUserSearch(index);
        };

        searchCtrl.removeUserCandidates = function (index) {
            searchService.deleteUserCandidates(index);
            searchCtrl.clearCandidates();
        };

        searchCtrl.saveUserSearch = function (update) {
            if (searchCtrl.userSearches.indexOf(searchCtrl.saveUserSearchName) >= 0 && !update) {
                searchCtrl.saveUserSearchHasError = true;
                return;
            }
            searchCtrl.searchCriteria.name = searchCtrl.saveUserSearchName;
            searchService.addUserSearch({
                searchName: searchCtrl.saveUserSearchName,
                searchData: searchCtrl.searchCriteriaFields,
            }, update);
            searchCtrl.saveUserSearchName = '';
            searchCtrl.saveUserSearchHasError = false;
            searchCtrl.showPanelSetting = false;
        };

        searchCtrl.saveUserCandidates = function (update) {
            if (searchCtrl.userCandidates.indexOf(searchCtrl.saveUserCandidatesName) >= 0 && !update) {
                searchCtrl.saveUserCandidatesHasError = true;
                return;
            }
            searchCtrl.searchCriteria.name = searchCtrl.saveUserCandidatesName;
            const candidates = [];

            const isNotResultListEmpty = _.get(searchCtrl, 'filteredCandidates.resultList.length');

            if (isNotResultListEmpty) {
                for (let i = 0; i < searchCtrl.filteredCandidates.resultList.length; i++) {
                    const listElement = searchCtrl.filteredCandidates.resultList[i];
                    if (listElement && listElement.check) {
                        candidates.push({
                            talentID: listElement.talentID,
                            fullName: listElement.fullName,
                            matchScore: listElement.matchScore,
                            predictionScore: listElement.predictionScore,
                            recruiterMatchScore: listElement.recruiterMatchScore,
                        });
                    }
                }
            }

            searchService.addUserCandidates({
                name: searchCtrl.saveUserCandidatesName,
                candidates,
            }, update);
            searchCtrl.saveUserCandidatesName = '';
            searchCtrl.saveUserCandidatesHasError = false;
            searchCtrl.showPanelCandiadtes = false;
        };

        searchCtrl.getUserSearch = function (index, save) {
            if (save === true) {
                searchCtrl.saveUserSearchName = searchCtrl.userSearches[index];
                searchCtrl.saveUserSearch(true);
                return;
            }
            searchService
                .getUserSearch(index)
                .then((response) => {
                    searchCtrl.searchName = searchCtrl.userSearches[index];
                    $sessionStorage.searchExplainScore = null;
                    searchCtrl.searchCriteriaFields = response.result;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.getUserPositionSearch = function () {
            $sessionStorage.searchExplainScore = null;
            searchCtrl.searchName = $sessionStorage.positionSearchName.name;
            searchCtrl.searchCriteriaFields = $sessionStorage.positionSearchName.criteria;
        };

        searchCtrl.addNote = function (addNoteData, form) {
            if (form.$invalid) {
                return;
            }
            searchCtrl
                .searchData
                .addNote(searchCtrl.currentCandidate, addNoteData);
            searchCtrl.showSideBar = 'default';
        };

        searchCtrl.addReminder = function (addReminderData, form) {
            if (form.$invalid) {
                return;
            }
            searchCtrl.showSideBar = 'default';
        };

        searchCtrl.startLoadingContactForm = () => {
            $timeout(() => searchCtrl.isContactFormLoading = true);
        };

        searchCtrl.stopLoadingContactForm = () => {
            $timeout(() => searchCtrl.isContactFormLoading = false);
        };

        searchCtrl.contactCandidate = async function (candidate, openCandidates, contactCandidate, goToNextCandidateCallback = () => {}) {
            try {
                searchCtrl.startLoadingContactForm();

                await searchCtrl
                    .searchData
                    .contactCandidate(candidate, openCandidates, contactCandidate, goToNextCandidateCallback);
            } catch (error) {
                logger.error(error.message);
            } finally {
                searchCtrl.stopLoadingContactForm();
            }
        };

        searchCtrl.sendMsg = async function (params) {
            const {
                candidate,
                openCandidates,
                contactCandidate,
                type,
                email,
                needToBeReloaded = true,
                flowType,
                selectedMessage,
            } = params;

            try {
                searchCtrl.startLoadingContactForm();

                if (contactCandidate.msgContent === '') {
                    searchCtrl.emptyMessage = true;
                    return;
                }
                if (contactCandidate.msgSubject && contactCandidate.msgSubject === '') {
                    searchCtrl.emptySubject = true;
                    return;
                }
                searchCtrl.emptyMessage = false;
                if (type === CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE && !contactCandidate.checkLinkedin) {
                    NotificationService.error('MESSAGE_SELECT_DESTINATION');
                    searchCtrl.emailOrLinkeError = true;
                    searchCtrl.emptyEmail = false;
                    return;
                }
                if (type === CONTACT_CHANNEL_TYPES.EMAIL && email.length <= 0) {
                    searchCtrl.emptyEmail = true;
                    searchCtrl.emailOrLinkeError = false;
                    return;
                }
                if (type === CONTACT_CHANNEL_TYPES.EMAIL) {
                    contactCandidate.checkEmail = true;
                    contactCandidate.checkLinkedin = false;
                }

                await searchCtrl
                    .searchData
                    .sendMsg({
                        candidate,
                        openCandidates,
                        contactCandidate,
                        type,
                        email,
                        needToBeReloaded,
                        flowType,
                        selectedMessage,
                    });
            } catch (error) {
                logger.error(error.message);
            } finally {
                searchCtrl.stopLoadingContactForm();
            }
        };

        searchCtrl.getUserCandidate = function (index, save) {
            if (save === true) {
                searchCtrl.saveUserCandidatesName = searchCtrl.userCandidates[index];
                searchCtrl.searchName = searchCtrl.userCandidates[index];
                searchCtrl.saveUserCandidates(true);
            }
            if (searchCtrl.currSearchHistoryIndex === 0) {
                searchCacheService.addSearch({
                    name: null,
                    fields: RouteService.getSystemPreference('searchCriteriaFields'),
                }, -1);
            }
            $timeout(() => {
                $state.go($state.current.name, {
                    currSearchHistoryIndex: searchCtrl.currSearchHistoryIndex + 1,
                    currCandidatePage: 1,
                    scroll: 0,
                    candidatesName: searchCtrl.userCandidates[index],
                    talentID: null,
                }, { reload: true });
            }, 300);
        };

        searchCtrl.candidateCheck = function () {
            const activeCandidates = searchCtrl.filteredCandidates.resultList
                .slice((searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage,
                    searchCtrl.currentPage * searchCtrl.candidatesPerPage);

            searchCtrl.talentIdsToExport = (searchCtrl.filteredCandidates.resultList || [])
                .filter(candidate => candidate.check)
                .map(candidate => candidate.talentID);

            searchCtrl.selectAllOnCurrentPage = activeCandidates.length && activeCandidates.every(({ check }) => check);
            searchCtrl.selectPartial = !searchCtrl.selectAllOnCurrentPage && activeCandidates.some(({ check }) => check);
            searchCtrl.isExportCsvVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkExportCSVIsAvailable();
            searchCtrl.isBulkClaimVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkBulkClaimIsAvailable();
        };

        searchCtrl.selectAllCandidatesOnCurrentPage = function () {
            searchCtrl.selectPartial = false;
            searchCtrl.selectAll = false;
            searchCtrl.selectAllOnCurrentPage = searchCtrl.selectAllCandidatesCheckboxIsChecked;

            _.forEach(searchCtrl.filteredCandidates.resultList, (listItem) => {
                listItem.check = searchCtrl.selectAll;
            });

            const candidateNumber = (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage;
            const totalCandidateNumber = searchCtrl.currentPage * searchCtrl.candidatesPerPage;
            // eslint-disable-next-line max-len
            for (let i = candidateNumber; i < totalCandidateNumber; i++) {
                if (i === searchCtrl.filteredCandidates.resultListLength) {
                    break;
                }
                const listElement = searchCtrl.filteredCandidates.resultList[i];
                if (listElement) {
                    listElement.check = searchCtrl.selectAllOnCurrentPage;
                }
            }

            searchCtrl.updateFilteredListOfCandidateToDisplay({ skipExplains: true });
        };

        searchCtrl.checkListItemsAreSelected = () => (_.get(searchCtrl, 'filteredListOfCandidatesToDisplay.length', 0) > 0)
            && (searchCtrl.selectPartial || searchCtrl.selectAllOnCurrentPage || searchCtrl.selectAll);

        searchCtrl.selectAllCandidates = () => {
            searchCtrl.openCheckBoxMenu = false;
            searchCtrl.selectPartial = false;
            searchCtrl.selectAllOnCurrentPage = false;
            searchCtrl.selectAll = true;
            searchCtrl.selectAllCandidatesCheckboxIsChecked = true;

            _.forEach(searchCtrl.filteredCandidates.resultList, (listItem) => {
                listItem.check = searchCtrl.selectAll;
            });

            searchCtrl.updateFilteredListOfCandidateToDisplay({ skipExplains: true });
        };

        searchCtrl.unCheckAll = function () {
            for (let i = 0; i < searchCtrl.filteredCandidates.resultList.length; i++) {
                const element = searchCtrl.filteredCandidates.resultList[i];
                if (element) {
                    element.check = false;
                }
            }

            searchCtrl.openCheckBoxMenu = false;
            searchCtrl.selectPartial = false;
            searchCtrl.selectAll = false;
            searchCtrl.selectAllOnCurrentPage = false;

            searchCtrl.updateFilteredListOfCandidateToDisplay({ skipExplains: true });

            searchCtrl.isExportCsvVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkExportCSVIsAvailable();
            searchCtrl.isBulkClaimVisible = searchCtrl.checkListItemsAreSelected() && searchCtrl.checkBulkClaimIsAvailable();
        };

        searchCtrl.getWorkflowName = function () {
            return _.get(searchCtrl, '$stateParams.workflowStep', searchCtrl.searchData.showView);
        };

        searchCtrl.checkExportCSVIsAvailable = () => {
            const workflowStep = searchCtrl.getWorkflowName();
            return !['Prospect'].includes(workflowStep);
        };

        searchCtrl.checkBulkClaimIsAvailable = () => {
            const workflowStep = searchCtrl.getWorkflowName();
            const isMethodExists = _.isFunction(searchCtrl.searchData.bulkClaimCandidates);
            const isAllowedTab = ['Prospect', 'MainSearch'].includes(workflowStep);

            return isMethodExists && isAllowedTab;
        };

        searchCtrl.goToNextCandidates = function () {
            if (searchCtrl.currentPage * searchCtrl.candidatesPerPage < searchCtrl.filteredCandidates.resultListLength) {
                searchCtrl.currentPage += 1;
            }
        };

        searchCtrl.clearSearch = function () {
            $state.go($state.current.name, {
                currSearchHistoryIndex: 0,
                currCandidatePage: 1,
                scroll: 0,
                candidatesName: null,
            }, { reload: $state.current.name });
        };

        searchCtrl.reloadPage = function () {
            $state.go($state.current.name, {
                scroll: 0,
            }, { reload: $state.current.name });
        };

        searchCtrl.clearCandidates = function () {
            $state.go($state.current.name, {
                currSearchHistoryIndex: 1,
                currCandidatePage: 1,
                scroll: 0,
                candidatesName: null,
            }, { reload: $state.current.name });
        };

        searchCtrl.logout = function () {
            RouteService.logout();
            AuthService.logout();
            $state.go('login');
        };

        searchCtrl.refreshLists = function () {
            RouteService
                .getRefreshMetaData()
                .catch(err => logger.error(err));
        };

        searchCtrl.filterData = function () {
            if (searchCtrl.filterSearchNameDelay) {
                $timeout.cancel(searchCtrl.filterSearchNameDelay);
            }
            if (searchCtrl.searchName && searchCtrl.searchName.length > 1) {
                searchCtrl.filterSearchNameDelay = $timeout(() => {
                    const reg_str = searchCtrl
                        .searchName
                        .split(/[^.\w]/)
                        .map(str => `(?=.*${str})`)
                        .join('');
                    const regex = new RegExp(`${reg_str}.+`, 'i');
                    const filteredCandidates = _.filter(searchCtrl.candidates.resultList, candidate => regex.exec(candidate.fullName));

                    searchCtrl.filteredCandidates = {
                        resultList: filteredCandidates,
                        resultListLength: filteredCandidates.length,
                    };

                    searchCtrl.getCurrentPageCandidates();
                    $scope.$apply();
                }, searchCtrl.searchNameFilterDelay, false);
            } else if (searchCtrl.searchName.length === 0) {
                searchCtrl.filteredCandidates = searchCtrl.candidates;
                searchCtrl.loading = true;

                if (searchCtrl.currentPage !== 1) {
                    searchCtrl.currentPage = 1;
                } else {
                    searchCtrl.getCurrentPageCandidates();
                }
            }
        };

        searchCtrl.editPreferences = function (form) {
            if (form.prefs.$invalid) {
                return;
            }
            TalentService
                .putTalent(searchCtrl.currentCandidate.talentID, {
                    preferences: [searchCtrl.preferencesEdit],
                })
                .then(() => {
                    searchCtrl.showPreferencesEdit = false;
                    searchCtrl.currentCandidate.candidateData.preferences = [searchCtrl.preferencesEdit];
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.editCandidateName = function (form) {
            form.$setSubmitted(true);
            if ((form.name.$invalid == true) ||
                (!searchCtrl.editCandidateNameEntity)) {
                const [nameInput = { $invalid: true }] = form.$$controls.filter(control => control.$name == 'name');
                nameInput.$invalid = true;
                return false;
            }
            TalentService
                .putTalent(searchCtrl.currentCandidate.talentID, {
                    name: searchCtrl.editCandidateNameEntity,
                })
                .then(() => {
                    searchCtrl.showEditCandidateName = false;
                    searchCtrl.currentCandidate.candidateData.name = searchCtrl.editCandidateNameEntity;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.editCandidateNameForSubmission = function (applicanDetails, candidateId, actionName, form) {
            form.$setSubmitted(true);
            if (form.name.$invalid || !applicanDetails.name) {
                const [nameInput = { $invalid: true }] = form.$$controls.filter(control => control.$name == 'name');

                nameInput.$invalid = true;

                return false;
            }

            searchCtrl.updateTalentForEmployer(applicanDetails, candidateId, actionName);
            searchCtrl.showCandidateNameEditTalentForEmployer = false;
            searchCtrl.currentCandidate.candidateData.name = applicanDetails.name;
        };

        searchCtrl.jobSeekerChange = function (jobSeeker) {
            if (jobSeeker.isJobSeekerManualSource == 'none' && jobSeeker.isJobSeekerManual != 'unknown') {
                jobSeeker.isJobSeekerManualSource = 'communication';
            }
            if (jobSeeker.isJobSeekerManual == 'undecided') {
                jobSeeker.isJobSeekerManualSource = 'communication';
            } else if (jobSeeker.isJobSeekerManual == 'unknown') {
                jobSeeker.isJobSeekerManualSource = 'none';
            }
        };

        searchCtrl.updateApplicantDetails = function (jobSeeker, form) {
            if (form && form.$invalid) {
                return;
            }
            if (jobSeeker.isJobSeekerManual == 'unknown') {
                jobSeeker.isJobSeekerManualSource = 'none';
            }
            TalentService
                .putTalentJobSeeker(searchCtrl.currentCandidate.talentID, {
                    status: jobSeeker.isJobSeekerManual,
                    source: jobSeeker.isJobSeekerManualSource,
                    comment: jobSeeker.isJobSeekerManualComment,
                })
                .then(() => {
                    searchCtrl.showApplicantDetailsEdit = false;
                    searchCtrl.getTalents({
                        talentIDs: [searchCtrl.currentCandidate.talentID],
                    });
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.initDatePicker = function () {
            $('.datetimepicker')
                .datepicker({
                    format: 'dd/mm/yyyy',
                    maxViewMode: 0,
                    orientation: 'bottom right',
                });
        };

        $rootScope.$on(ERROR_EVENTS.frontTimeout, () => {
            searchCtrl.loading = false;
        });

        searchCtrl.updateProfile = function () {
            const { talentId } = searchCtrl.currentCandidate.candidateData;
            if (!talentId) {
                return;
            }
            TalentService
                .postTalentForCreationByTalentId(talentId)
                .then((response) => {
                    if (response.message) {
                        NotificationService.error(response.message);
                    } else {
                        const message = _.get(response, 'result[0].message');
                        NotificationService.success(message);
                    }
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.getTalentsForEmployer = function () {
            TalentForEmployerService
                .searchTalentForEmployer({ talentId: searchCtrl.currentCandidate.workflow.talentId })
                .then((response) => {
                    searchCtrl.currentCandidate.talentRecordsForEmployer = response.result;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.openJobSeekerEdit = function () {
            searchCtrl.candidateTab = 'profile';
            searchCtrl.showMore = true;
            searchCtrl.showJobSeekingEdit = true;
        };

        searchCtrl.getRecruiterData = function () {
            if (searchCtrl.currentInterview && searchCtrl.currentInterview.recruiterId) {
                RecruiterService
                    .getRecruiter(searchCtrl.currentInterview.recruiterId)
                    .then((response) => {
                        searchCtrl.currentInterview.recuiterData = response.result;
                    })
                    .catch(err => logger.error(err));
            }
        };

        searchCtrl.copyTalentData = function () {
            const newCandidateData = angular.copy(searchCtrl.currentCandidate.candidateData);
            if (newCandidateData.contact.emailAddress == null || newCandidateData.contact.emailAddress.length == 0) {
                newCandidateData.contact.emailAddress = [
                    {
                        type: 'work',
                        value: '',
                    },
                ];
            } else {
                newCandidateData.contact.emailAddress = _.map(newCandidateData.contact.emailAddress, email => ({
                    value: email,
                    type: 'Work',
                }));
            }
            if (newCandidateData.contact.mobile == null || newCandidateData.contact.mobile.length == 0) {
                newCandidateData.contact.mobile = [
                    {
                        type: 'work',
                        value: '',
                    },
                ];
            } else {
                newCandidateData.contact.mobile = _.map(newCandidateData.contact.mobile, mobile => ({
                    value: mobile,
                    type: 'Work',
                }));
            }
            if (newCandidateData.contact.telephone == null || newCandidateData.contact.telephone.length == 0) {
                newCandidateData.contact.telephone = [
                    {
                        type: 'work',
                        value: '',
                    },
                ];
            } else {
                newCandidateData.contact.telephone = _.map(newCandidateData.contact.telephone, telephone => ({
                    value: telephone,
                    type: 'Work',
                }));
            }
            newCandidateData.contact.regularWebsites = _.remove(newCandidateData.contact.webAddress, utils.isWebsite);

            if (newCandidateData.contact.regularWebsites == null || newCandidateData.contact.regularWebsites.length == 0) {
                newCandidateData.contact.regularWebsites = [
                    {
                        type: 'website',
                        value: '',
                    },
                ];
            }

            searchCtrl.staticData = [
                {
                    title: '',
                    field: 'industries',
                    lookupData: 'industries',
                    type: 'static',
                    dropDownText: 'ADD_INDUSTRY',
                    subCriteria: null,
                    multiple: false,
                    selected: _.map(newCandidateData.industry, value => ({
                        uid: value.industryId,
                        value: value.industryName,
                        required: 'optional',
                    })),
                    setAsMandatory: false,
                },
            ];
            return newCandidateData;
        };

        searchCtrl.cleanUpEmptyAndFlattenTalentContactData = function (talentData) {
            const isEmpty = value => (value === '' || value == null);

            _.remove(talentData.contact.webAddress, item => isEmpty(item.url));
            _.remove(talentData.contact.regularWebsites, item => isEmpty(item.url));
            _.remove(talentData.contact.emailAddress, item => isEmpty(item.value));
            _.remove(talentData.contact.mobile, item => isEmpty(item.value));
            _.remove(talentData.contact.telephone, item => isEmpty(item.value));

            talentData.contact.webAddress = talentData
                .contact
                .webAddress
                .concat(talentData.contact.regularWebsites);
            talentData.contact.emailAddress = _.map(talentData.contact.emailAddress, 'value');
            talentData.contact.mobile = _.map(talentData.contact.mobile, 'value');
            talentData.contact.fax = _.map(talentData.contact.fax, 'value');
            talentData.contact.telephone = _.map(talentData.contact.telephone, 'value');
        };

        searchCtrl.updateTalentData = function (talentData, id, editView, changedData) {
            if (talentData.contact && changedData === 'contact') {
                searchCtrl.cleanUpEmptyAndFlattenTalentContactData(talentData);
                delete talentData.contact.regularWebsites; // remove regularWebsite from the sent json

                if (editView == 'showApplicantDetailsEdit') {
                    delete talentData.residency; // remove residency from the sent json
                    delete talentData.location; // remove residency from the sent json
                }
                updateTalentDataService(id, {
                    contact: talentData.contact,
                }, editView);
                return;
            }
            talentData.industry = _.map(searchCtrl.staticData[0].selected, value => ({
                industryId: value.uid,
                industryName: value.value,
            }));

            if (editView == 'showApplicantDetailsEdit') {
                delete talentData.residency; // remove residency from the sent json
                delete talentData.location; // remove residency from the sent json
                updateTalentDataService(id, talentData, editView);
            } else if (editView == 'showTalentResidency' && changedData === 'residency') {
                if (!checkIfAllFieldsValid(talentData.residency)) {
                    const promises = [];
                    promises.push(searchCtrl.getLocationLangLat(talentData.residency));
                    $q
                        .all(promises)
                        .then(() => {
                            updateTalentDataService(id, {
                                residency: talentData.residency,
                            }, editView);
                        })
                        .catch(err => logger.error(err));
                } else {
                    talentData.residency.geoLocation = null;
                    talentData.location.geoLocation = null;
                    updateTalentDataService(id, {
                        residency: talentData.residency,
                    }, editView);
                }
            }
        };

        let checkIfAllFieldsValid = function (talentData) {
            return !talentData.address && !talentData.city && !talentData.country && !talentData.region && !talentData.state;
        };

        const updateChangedDataOnly = function (data) {
            if (data.residency) {
                searchCtrl.currentCandidate.candidateData.residency = data.residency;
            }
            if (data.location) {
                searchCtrl.currentCandidate.candidateData.location = data.location;
            }
            if (data.contact) {
                searchCtrl.currentCandidate.candidateData.contact = data.contact;
            }
        };

        let updateTalentDataService = function (id, talentData, editView) {
            TalentService
                .putTalent(id, talentData)
                .then(() => {
                    updateChangedDataOnly(talentData);
                    if (editView === 'showTalentResidency') {
                        searchCtrl.currentCandidate.residency =
                            CommonCodeService.getLocationString(searchCtrl.currentCandidate.candidateData.residency);
                    }
                    searchCtrl[editView] = false;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.copyTalentForEmployer = function () {
            const newTalentRecord = angular.copy(searchCtrl.talentRecord.candidateData);

            const transformItem = item => ({
                type: 'Work',
                value: item,
            });

            const transformFieldValue = (values) => {
                if (values == null || values.length === 0) {
                    return [{
                        type: 'work',
                        value: '',
                    }];
                }
                return _.map(values, transformItem);
            };

            newTalentRecord.contact.emailAddress = transformFieldValue(newTalentRecord.contact.emailAddress);
            newTalentRecord.contact.mobile = transformFieldValue(newTalentRecord.contact.mobile);
            newTalentRecord.contact.telephone = transformFieldValue(newTalentRecord.contact.telephone);

            newTalentRecord.contact.regularWebsites = _.remove(newTalentRecord.contact.webAddress, utils.isWebsite);

            if (newTalentRecord.contact.regularWebsites === null || newTalentRecord.contact.regularWebsites.length === 0) {
                newTalentRecord.contact.regularWebsites = [
                    {
                        type: 'website',
                        value: '',
                    },
                ];
            }
            searchCtrl.staticData = [
                {
                    title: '',
                    field: 'industries',
                    lookupData: 'industries',
                    type: 'static',
                    dropDownText: 'ADD_INDUSTRY',
                    subCriteria: null,
                    multiple: false,
                    selected: _.map(newTalentRecord.industry, value => ({
                        uid: value.industryId,
                        value: value.industryName,
                        required: 'optional',
                    })),
                    showMultipleInput: true,
                    setAsMandatory: false,
                }, {
                    title: '',
                    field: 'skills',
                    type: 'dynamic',
                    dropDownText: 'ADD_SKILL',
                    subCriteria: null,
                    multiple: true,
                    selected: _.map(newTalentRecord.skills, value => ({
                        uid: value.skillId,
                        isDerived: value.isDerived,
                        value: value.skillName,
                        required: 'optional',
                    })),
                    setAsMandatory: false,
                }, {
                    title: '',
                    field: 'companies',
                    type: 'dynamic',
                    dropDownText: 'ADD_COMPANY',
                    subCriteria: null,
                    multiple: false,
                    selected: [],
                    setAsMandatory: false,
                }, {
                    title: '',
                    field: 'jobTitles',
                    type: 'dynamic',
                    dropDownText: 'ENTER_A_JOB_TITLE',
                    subCriteria: null,
                    multiple: true,
                    selected: [],
                    setAsMandatory: false,
                }, {
                    title: '',
                    field: 'schools',
                    type: 'semiDynamic',
                    dropDownText: 'ADD_SCHOOL',
                    subCriteria: null,
                    multiple: false,
                    selected: [],
                    setAsMandatory: false,
                }, {
                    title: '',
                    field: 'educationLevel',
                    type: 'dynamic',
                    dropDownText: 'ADD_EDUCATION_LEVEL',
                    subCriteria: null,
                    multiple: false,
                    selected: [],
                    setAsMandatory: false,
                },
            ];

            searchCtrl.monthsOfYear = [
                'JAN',
                'FEB',
                'MARCH',
                'APRIL',
                'MAY',
                'JUNE',
                'JULY',
                'AUG',
                'SEP',
                'OCT',
                'NOV',
                'DEC',
            ].map((month, index) => ({ id: index, name: month }));

            newTalentRecord.languages = _.map(newTalentRecord.languages, (language) => {
                language.staticData = {
                    title: '',
                    field: 'languages',
                    lookupData: 'languages',
                    type: 'static',
                    dropDownText: 'ENTER_A_LANGUAGE',
                    subCriteria: null,
                    multiple: false,
                    selected: [
                        {
                            uid: language.languageCodeId,
                            value: $filter('getLanguageName')(language, searchCtrl.lookupLanguages),
                            required: 'optional',
                        },
                    ],
                    showMultipleInput: true,
                    setAsMandatory: false,
                };
                return language;
            });

            return newTalentRecord;
        };

        searchCtrl.getUrlByType = function (contact, type) {
            const website = _.find(contact.webAddress, { type });

            if (website) {
                return website;
            }

            const newData = {
                type,
                url: '',
            };

            if (!contact.webAddress) {
                contact.webAddress = [];
            }

            contact
                .webAddress
                .push(newData);

            return newData;
        };

        searchCtrl.updateTalentForEmployer = function (talentData, id, editView) {
            if (!talentData.newLanguage && _.findIndex(talentData.languages, language => (language.staticData.selected.length <= 0 || language.staticData.selected[0].uid == '')) >= 0) {
                return;
            }

            if (talentData.contact) {
                searchCtrl.cleanUpEmptyAndFlattenTalentContactData(talentData);
            }

            if (searchCtrl.staticData[0]) {
                talentData.industry = _.map(searchCtrl.staticData[0].selected, value => ({
                    industryId: value.uid,
                    industryName: value.value,
                }));
            }

            if (searchCtrl.staticData[1]) {
                talentData.skills = _.map(searchCtrl.staticData[1].selected, value => ({
                    skillId: value.uid,
                    skillName: value.value,
                    isDerived: value.isDerived,
                }));
            }
            if (talentData.newEmployment == true) {
                talentData.employmentHistory = talentData
                    .employmentHistory
                    .concat(searchCtrl.talentRecord.candidateData.employmentHistory);
            }
            if (talentData.newEducation == true) {
                talentData.educationHistory = talentData
                    .educationHistory
                    .concat(searchCtrl.talentRecord.candidateData.educationHistory);
            }
            if (talentData.newLanguage == true) {
                talentData.languages = talentData
                    .languages
                    .concat(searchCtrl.talentRecord.candidateData.languages);
            }
            if (talentData.employmentHistory) {
                talentData.employmentHistory = _.map(talentData.employmentHistory, (employment) => {
                    if (employment.startMonth || employment.startYear) {
                        employment.startDate = (new Date(employment.startYear, employment.startMonth, 2)).toISOString();
                    }
                    if (employment.isCurrent) {
                        employment.endDate = null;
                    } else if (employment.endMonth || employment.endYear) {
                        employment.endDate = (new Date(employment.endYear, employment.endMonth, 2)).toISOString();
                    }
                    if (employment.employmentCompanyFilter && employment.employmentCompanyFilter.selected.length > 0) {
                        employment.employerOrgId = employment.employmentCompanyFilter.selected[0].uid;
                        employment.employerOrgName = employment.employmentCompanyFilter.selected[0].value;
                    } else if (employment.employmentCompanyFilter) {
                        employment.employerOrgId = null;
                        employment.employerOrgName = null;
                    }
                    if (employment.employmentTitlesFilter && employment.employmentTitlesFilter.selected.length > 0) {
                        employment.titles = _.map(employment.employmentTitlesFilter.selected, value => ({
                            titleId: value.uid,
                            title: value.value,
                        }));
                    } else if (employment.employmentTitlesFilter) {
                        employment.titles = [];
                    }
                    let eDate = new Date();
                    if (employment.endDate) {
                        eDate = new Date(employment.endDate);
                    }
                    employment.monthsOfWork = monthDiff(new Date(employment.startDate), eDate);
                    return employment;
                });
                talentData.employmentHistory = _.orderBy(talentData.employmentHistory, [
                    function (employment) {
                        if (!employment.endDate) {
                            return new Date();
                        }
                        return new Date(employment.endDate);
                    },
                    function (employment) {
                        return new Date(employment.startDate);
                    },
                ], ['desc', 'desc']);
            }

            if (talentData.educationHistory) {
                talentData.educationHistory = _.map(talentData.educationHistory, (education) => {
                    if (education.startYear) {
                        education.startDate = (new Date(education.startYear, 0, 2)).toISOString();
                    }
                    if (education.isCurrent) {
                        education.endDate = null;
                    } else if (education.endYear) {
                        education.endDate = (new Date(education.endYear, 0, 2)).toISOString();
                    }
                    if (education.educationHistoryFilter && education.educationHistoryFilter.selected.length > 0) {
                        education.schoolId = education.educationHistoryFilter.selected[0].uid;
                        education.schoolName = education.educationHistoryFilter.selected[0].value;
                    } else if (education.educationHistoryFilter) {
                        education.schoolId = null;
                        education.schoolName = null;
                    }
                    if (education.educationDegreeFilter && education.educationDegreeFilter.selected) {
                        education.degree = education.educationDegreeFilter.selected;
                    } else if (education.educationDegreeFilter) {
                        education.degree = [];
                    }
                    let eDate = new Date();
                    if (education.endDate) {
                        eDate = new Date(education.endDate);
                    }
                    education.monthsOfWork = monthDiff(new Date(education.startDate), eDate);
                    return education;
                });
                talentData.educationHistory = _.orderBy(talentData.educationHistory, [
                    function (education) {
                        if (!education.endDate) {
                            return new Date();
                        }
                        return new Date(education.endDate);
                    },
                    function (education) {
                        return new Date(education.startDate);
                    },
                ], ['desc', 'desc']);
                searchCtrl.cleanMyJson(talentData);
            }

            talentData.languages = _.map(talentData.languages, (language) => {
                if (language.languageFilter && language.languageFilter.selected.length > 0) {
                    language.languageCodeId = language.languageFilter.selected[0].uid;
                    language.languageCode = language.languageFilter.selected[0].value;
                } else if (language.staticData && language.staticData.selected.length > 0) {
                    language.languageCodeId = language.staticData.selected[0].uid;
                    language.languageCode = language.staticData.selected[0].value;
                } else if (language.languageFilter) {
                    language.languageCodeId = null;
                    language.languageCode = null;
                }
                delete language.languageFilter;
                return language;
            });

            if (editView == 'showTalentResidency') {
                const promises = [];
                promises.push(searchCtrl.getLocationLangLat(talentData.residency));
                $q
                    .all(promises)
                    .then(() => {
                        this.serviceUpdateTalent(id, talentData, editView);
                    })
                    .catch(err => logger.error(err));
            } else {
                delete talentData.residency; // remove residency from the sent json
                delete talentData.location; // remove residency from the sent json
                this.serviceUpdateTalent(id, talentData, editView);
            }
        };

        this.serviceUpdateTalent = function (id, talentData, editView) {
            return TalentForEmployerService.updateTalentForEmployer(id, talentData)
                .then(() => {
                    if (talentData.newEmployment) {
                        searchCtrl.talentRecord.candidateData.employmentHistory = talentData.employmentHistory;
                    } else if (talentData.newLanguage) {
                        searchCtrl.talentRecord.candidateData.languages = talentData.languages;
                    } else if (talentData.newEducation) {
                        searchCtrl.talentRecord.candidateData.educationHistory = talentData.educationHistory;
                    } else {
                        if (!talentData.location) {
                            talentData.location = searchCtrl.talentRecord.candidateData.location;
                        }
                        if (!talentData.residency) {
                            talentData.residency = searchCtrl.talentRecord.candidateData.residency;
                        }

                        searchCtrl.talentRecord.candidateData = talentData;
                    }

                    searchCtrl.talentRecord.candidateData.industry = talentData.industry;
                    searchCtrl.talentRecord.candidateData.skills = talentData.skills;

                    // Send residency only if we are changing the Residency
                    if (editView === 'showTalentResidency') {
                        searchCtrl.talentRecord.residency = CommonCodeService.getLocationString(searchCtrl.talentRecord.candidateData.residency);
                    }

                    const [event] = searchCtrl.currentCandidate.workflow.events;
                    const contactDetailsSection = 'showTalentForEmployerApplicantDetailsEdit';
                    const expertObservationSection = 'showPreferencesEditTalentForEmployer';
                    const isResumeCreated = event.eventType !== WorkflowService.eventTypes.RESUME_CREATED;
                    const needToCreateResume = isResumeCreated && (editView !== contactDetailsSection) && (editView !== expertObservationSection);
                    const needToAprroveResume = searchCtrl.candidateTab === 'talent_for_employer' && searchCtrl.showSideBar === 'sendResumeToCandidate';

                    if (needToCreateResume) {
                        const event = {
                            eventType: WorkflowService.eventTypes.RESUME_CREATED,
                            content: {
                                message: 'Talent Expert updated resume',
                            },
                            entityId: id,
                        };

                        const currentRecruiterId = _.get(searchCtrl, 'searchData.recruiterId');
                        if (currentRecruiterId) {
                            event.recruiterId = currentRecruiterId;
                        }
                        WorkflowService.postWorkflowEvent(searchCtrl.currentCandidate.workflow._id, event)
                            .then(() => {
                                $sessionStorage.candidateTab = 'talent_for_employer';
                                $state.go($state.current.name, {}, { reload: true });
                            })
                            .catch(err => logger.error(err));
                    } else if (needToAprroveResume) {
                        searchCtrl.showSideBar = 'default';
                        $timeout(() => {
                            searchCtrl.sendToCandidateButtonClick();
                        });
                    }

                    if (editView === expertObservationSection) {
                        const expertObservationValue = _.get(searchCtrl, 'talentRecord.candidateData.preferences[0]');
                        if (!_.isEmpty(expertObservationValue)) {
                            searchCtrl.currentCandidate.moveToReadyBlockedObservations = false;
                        }
                    }

                    if (editView === contactDetailsSection) {
                        const talentContactData = _.get(searchCtrl, 'talentRecord.candidateData.contact');

                        const isEmailExists = !_.isEmpty(talentContactData.emailAddress);
                        const isMobileExists = !_.isEmpty(talentContactData.mobile);
                        const isTelephoneExists = !_.isEmpty(talentContactData.telephone);

                        if (isEmailExists || isMobileExists || isTelephoneExists) {
                            searchCtrl.currentCandidate.moveToReadyBlockedContact = false;
                            searchCtrl.currentCandidate.moveToReadyBlockedEmailMissing = false;
                            searchCtrl.currentCandidate.moveToReadyBlockedPhoneMissing = false;
                            searchCtrl.currentCandidate.moveToReadyBlockedTelephoneMissing = false;
                        }
                    }

                    searchCtrl[editView] = false;
                })
                .catch(err => logger.error(err));
        };

        function monthDiff(d1, d2) {
            let months;
            months = (d2.getFullYear() - d1.getFullYear()) * 12;
            months -= d1.getMonth() + 1;
            months += d2.getMonth();
            return months <= 0
                ? 0
                : months;
        }

        searchCtrl.initEmploymentJob = function (employment) {
            employment.employmentCompanyFilter = angular.copy(searchCtrl.staticData[2]);
            if (employment.employerOrgId || employment.employerOrgName) {
                employment.employmentCompanyFilter.selected = [
                    {
                        uid: employment.employerOrgId || 0,
                        value: employment.employerOrgName || '',
                        required: 'optional',
                    },
                ];
            }
            employment.employmentTitlesFilter = angular.copy(searchCtrl.staticData[3]);
            employment.employmentTitlesFilter.selected = _.map(employment.titles, value => ({
                uid: value.titleId,
                value: value.title,
                required: 'optional',
            }));
            if (employment.startDate) {
                const date = new Date(employment.startDate);
                employment.startMonth = date.getMonth();
                employment.startYear = date.getFullYear();
            }

            if (employment.endDate) {
                const date = new Date(employment.endDate);
                employment.endMonth = date.getMonth();
                employment.endYear = date.getFullYear();
            }
        };

        searchCtrl.initEducationHistory = function (education) {
            education.educationHistoryFilter = angular.copy(searchCtrl.staticData[4]);
            if (education.schoolId || education.schoolName) {
                education.educationHistoryFilter.selected = [
                    {
                        uid: education.schoolId || 0,
                        value: education.schoolName || '',
                        required: 'optional',
                    },
                ];
            }
            education.educationDegreeFilter = angular.copy(searchCtrl.staticData[5]);
            if (education.degree && (education.degree.majorId || education.degree.major)) {
                education.educationDegreeFilter.selected = [
                    {
                        uid: education.degree.majorId || 0,
                        value: education.degree.major || '',
                        required: 'optional',
                    },
                ];
            } else {
                education.educationDegreeFilter.selected = [];
            }

            if (education.startDate) {
                const date = new Date(education.startDate);
                education.startYear = date.getFullYear();
            }

            if (education.endDate) {
                const date = new Date(education.endDate);
                education.endYear = date.getFullYear();
            }
        };

        searchCtrl.initAddEmployment = function () {
            return [
                {
                    description: null,
                    employerOrgId: null,
                    employerOrgName: null,
                    endDate: null,
                    isCurrent: true,
                    jobArea: null,
                    orgIcon: null,
                    orgName: null,
                    startDate: null,
                    titles: [],
                },
            ];
        };

        searchCtrl.initAddEducation = function () {
            return [
                {
                    description: null,
                    endDate: null,
                    isCurrent: true,
                    schoolName: null,
                    startDate: null,
                    degree: {
                        major: null,
                        majorId: null,
                    },
                },
            ];
        };

        searchCtrl.openModalDialog = function (data) {
            searchCtrl.modalDialogData = data;
            $('#recruiterModalDialog')
                .modal('show');
            searchCtrl.modalDialog = true;
        };

        searchCtrl.closeModalDialog = function () {
            window.onbeforeunload = null;
            searchCtrl.bulkModeActive = false;
            searchCtrl.modalDialogData = null;
            $('#recruiterModalDialog')
                .modal('hide');
            searchCtrl.modalDialog = false;
        };

        searchCtrl.sendResumeToEmployerInterviewChanged = function (interview, sendResumeToEmployer) {
            if (interview) {
                sendResumeToEmployer.interview = angular.copy(interview);
                sendResumeToEmployer.interview.statusCurrentJob = _.find(searchCtrl.interviewStatusCurrentJob, {
                    value: sendResumeToEmployer.interview.statusCurrentJob,
                });
                if (sendResumeToEmployer.value) {
                    const temp = sendResumeToEmployer.value;
                    $timeout(() => {
                        sendResumeToEmployer.value = temp;
                    }, 100);
                }
            }
        };

        searchCtrl.multiSendResumeToEmployer = function () {
            if ((searchCtrl.talenyaUser) || (!searchCtrl.talenyaUser && searchCtrl.canSendToEmployer)) {
                RecruiterService
                    .getRecruiter(searchCtrl.searchData.recruiterId)
                    .then((response) => {
                        searchCtrl.recruiterData = response.result;
                        let language = RouteService.getUserPreference('uiLanguage');
                        if (!language) {
                            language = 'en-US';
                        }
                        RouteService
                            .getEmailTemplates(language, 'profilesEmployer')
                            .then((response) => {
                                searchCtrl.contactUserTemplates = [];
                                const resumes = [];
                                // eslint-disable-next-line max-len
                                for (let i = (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage; i < searchCtrl.currentPage * searchCtrl.candidatesPerPage; i++) {
                                    if (i >= searchCtrl.filteredCandidates.resultListLength || i < 0) {
                                        break;
                                    }
                                    const element = searchCtrl.filteredCandidates.resultList[i];
                                    if (element && element.check) {
                                        resumes.push(element);
                                    }
                                }
                                searchCtrl.userData = {
                                    positionData: searchCtrl.searchData.positionData,
                                    candidateData: null,
                                    candidatesData: resumes,
                                    emailType: 'employer',
                                };
                                if (response.result && response.result.templates) {
                                    searchCtrl.contactUserTemplates = searchCtrl
                                        .searchData
                                        .changeTemplateTags(
                                            response.result.templates,
                                            null,
                                            searchCtrl.recruiterData,
                                            searchCtrl.searchData.positionData,
                                            response.result.type,
                                        );
                                }
                                searchCtrl.modalDialogView = 'multiSendResumeToEmployerView.html';
                                searchCtrl.openModalDialog({});
                            })
                            .catch(err => logger.error(err));
                    })
                    .catch(err => logger.error(err));
            }
        };

        searchCtrl.multiBackToProspectsModal = function () {
            searchCtrl.modalDialogView = 'multiBackToProspectView.html';
            searchCtrl.openModalDialog({});
        };

        searchCtrl.multiBackToCompleteSourcingModal = function () {
            searchCtrl.modalDialogView = 'sendBackToCompleteSourcingView.html';
            searchCtrl.openModalDialog({});
        };

        searchCtrl.approveSubmissionInterviewChanged = function (interview, approveSubmission) {
            if (interview) {
                approveSubmission.interview = null;
                $timeout(() => {
                    approveSubmission.interview = angular.copy(interview);
                    approveSubmission.interview.statusCurrentJob = _.find(searchCtrl.interviewStatusCurrentJob, {
                        value: approveSubmission.interview.statusCurrentJob,
                    });
                });
            }
        };

        searchCtrl.getLocationLangLat = function (location) {
            const deferred = $q.defer();
            LocationService
                .getLognitudeLatitude(location.country, location.city, '')
                .then((response) => {
                    location.geoLocation = {};
                    location.geoLocation.coordinates = [];
                    if (response.data && response.data.results && response.data.results.length > 0) {
                        location
                            .geoLocation
                            .coordinates
                            .push(response.data.results[0].geometry.location.lat);
                        location
                            .geoLocation
                            .coordinates
                            .push(response.data.results[0].geometry.location.lng);
                        location.geoLocation.type = 'Point';
                        return deferred.resolve(location);
                    }
                    if (response.data.status == 'ZERO_RESULTS') {
                        return LocationService
                            .getLognitudeLatitude(location.country, '', '')
                            .then((response) => {
                                if (response.data && response.data.results && response.data.results.length > 0) {
                                    location
                                        .geoLocation
                                        .coordinates
                                        .push(response.data.results[0].geometry.location.lat);
                                    location
                                        .geoLocation
                                        .coordinates
                                        .push(response.data.results[0].geometry.location.lng);
                                    location.geoLocation.type = 'Point';
                                    deferred.resolve(location);
                                }
                                deferred.resolve(null);
                            })
                            .catch(err => logger.error(err));
                    }
                    deferred.resolve(null);
                })
                .catch(err => logger.error(err));

            return deferred.promise;
        };

        searchCtrl.sendMultipleResumesToEmployer = function (body) {
            const resumes = [];
            // eslint-disable-next-line max-len
            for (let i = (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage; i < searchCtrl.currentPage * searchCtrl.candidatesPerPage; i++) {
                if (i >= searchCtrl.filteredCandidates.resultListLength || i < 0) {
                    break;
                }
                const element = searchCtrl.filteredCandidates.resultList[i];
                if (element && element.check) {
                    resumes.push(element);
                }
            }
            searchCtrl
                .searchData
                .multiSendResumeToEmployer(resumes, searchCtrl.openCandidates, body);
            $('#recruiterModalDialog')
                .modal('hide');
        };

        searchCtrl.sendBackToCompleteSourcing = function (candidate = null) {
            const candidates = [];
            if (candidate) {
                candidates.push(candidate);
            } else {
                const startIndex = (searchCtrl.currentPage - 1) * searchCtrl.candidatesPerPage;
                const endIndex = searchCtrl.currentPage * searchCtrl.candidatesPerPage;
                for (let i = startIndex; i < endIndex; i++) {
                    if (i >= searchCtrl.filteredCandidates.resultListLength || i < 0) {
                        break;
                    }
                    const element = searchCtrl.filteredCandidates.resultList[i];
                    if (element && element.check) {
                        candidates.push(element);
                    }
                }
            }
            if (candidates.length > 0) {
                $scope.moveWorkflowsToFullService(candidates);
            }
            $('#recruiterModalDialog')
                .modal('hide');
        };

        $scope.moveWorkflowsToFullService = function (candidates) {
            const workflowIds = (candidates || []).map((item) => {
                const workflow = item.workflow;
                return workflow ? workflow._id : null;
            })
                .filter(item => item);

            if (workflowIds.length > 0) {
                WorkflowService.moveWorkflowsToFullService({ workflowIds: [...workflowIds] })
                    .then(() => {
                        NotificationService.success('EMPLOYER_VIEW_BACK_TO_TE_NOTIFCATION');
                        $timeout(() => {
                            $state.go($state.current.name, {
                                scroll: 0,
                            }, { reload: $state.current.name });
                        }, 200);
                    })
                    .catch(err => logger.error(err));
            }
        };

        searchCtrl.initLanguage = function (language) {
            language.languageFilter = angular.copy({
                title: '',
                field: 'languages',
                lookupData: 'languages',
                type: 'static',
                dropDownText: 'ENTER_A_LANGUAGE',
                subCriteria: null,
                multiple: false,
                selected: [],
                showMultipleInput: true,
                setAsMandatory: false,
            });
        };

        searchCtrl.initAddLanguage = function () {
            return [
                {
                    languageCode: null,
                    languageCodeId: null,
                    proficiency: null,
                },
            ];
        };

        searchCtrl.deleteLanguage = function (languages, idx) {
            languages.splice(idx, 1);
        };

        searchCtrl.editComment = function (candidate, data, form) {
            if (form.$invalid) {
                return;
            }
            CandidateService
                .putCandidateComments(candidate.workflow.candidateId, data._id, { content: data.commentEdit })
                .then(() => {
                    data.content = data.commentEdit;
                    data.showCommentEdit = false;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.deleteComment = (candidate, data, index) => {
            if (index >= 0) {
                searchCtrl
                    .currentCandidate
                    .comments = (searchCtrl.currentCandidate.comments || [])
                        .filter(item => item._id !== data._id);
            }

            CandidateService.deleteCandidateComment(candidate.workflow.candidateId, data._id);
        };

        searchCtrl.approveProfile = function () {
            CandidateApprovalService
                .approveSubmission(searchCtrl.currentCandidate.workflow._id)
                .then(() => {
                    $state.go($state.current.name, {
                        scroll: 0,
                    }, { reload: $state.current.name });
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.initEmailData = function () {
            searchCtrl.emailData = [];
            for (let i = 0; i < searchCtrl.searchData.positionData.contact.email.length; i++) {
                searchCtrl
                    .emailData
                    .push(searchCtrl.searchData.positionData.contact.email[i].value);
            }
        };

        searchCtrl.initFormResidency = function () {
            $timeout(() => {
                searchCtrl.applicanDetails = searchCtrl.copyTalentForEmployer();
                searchCtrl.tempResidency = angular.copy(searchCtrl.applicanDetails.residency);
            });
        };

        searchCtrl.checkIfFieldResidencyChange = function () {
            if (!angular.equals(searchCtrl.applicanDetails.residency, searchCtrl.tempResidency)) {
                searchCtrl.updateTalentForEmployer(searchCtrl.applicanDetails, searchCtrl.talentRecord.candidateData._id, 'showTalentResidency');
            }
        };

        searchCtrl.initFormResidencyProfile = function () {
            searchCtrl.applicanDetails = searchCtrl.copyTalentData();
            searchCtrl.tempResidencyProfile = angular.copy(searchCtrl.applicanDetails.residency);
        };

        searchCtrl.checkIfFieldResindencyProfileChange = function () {
            searchCtrl.updateTalentData(searchCtrl.applicanDetails, searchCtrl.currentCandidate.candidateData.talentId, 'showTalentResidency', 'residency');
        };

        searchCtrl.capitalizeName = function (fullname) {
            let capitalizedName = '';
            const nameArr = fullname.split(' ');
            let newTemp;
            let tempFirstCharUpper;
            let tempWithoutFirstLetter;
            for (let i = 0; i < nameArr.length; i++) {
                if (i > 0) {
                    capitalizedName += ' ';
                }
                newTemp = '';
                tempFirstCharUpper = '';
                tempWithoutFirstLetter = '';
                tempFirstCharUpper = nameArr[i]
                    .charAt(0)
                    .toUpperCase();
                tempWithoutFirstLetter = nameArr[i].slice(1);
                newTemp = tempFirstCharUpper + tempWithoutFirstLetter;
                capitalizedName += newTemp;
            }
            return capitalizedName;
        };

        searchCtrl.copyToClipboard = function (data) {
            this.clipboard.copyText(data);
            NotificationService.success('Copied');
        };

        searchCtrl.initContactCandidate = async function (channel) {
            try {
                const language = RouteService.getUserPreference('uiLanguage') || 'en-US';
                const candidateEmails = _.get(searchCtrl, 'candidateToContact.candidateData.contact.emailAddress', []);

                const candidateWebAddress = _.get(searchCtrl, 'candidateToContact.candidateData.contact.webAddress', []);
                const candidateLinkedIn = (
                    candidateWebAddress.find((address => address.type === CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE),
                    ) || {}).url;

                const [
                    { result: recruiter },
                    { templates, campaign },
                    { result: positionApprovalLinkData },
                ] = await Promise.all([
                    RecruiterService.getRecruiter(searchCtrl.searchData.recruiterId),
                    ContactCandidateService.getContactCampaignDetails({
                        channel,
                        language,
                        positionId: searchCtrl.currentCandidate.workflow.positionId,
                    }),
                    // RouteService.getEmailTemplates(language, templateName),
                    RouteService.getPositionApprovalLinks($stateParams.positionId, {
                        candidates: [{
                            emails: candidateEmails,
                            talentId: searchCtrl.currentCandidate.workflow.talentId,
                            workflowId: searchCtrl.currentCandidate.workflow._id,
                            channelType: channel,
                            linkedIn: candidateLinkedIn,
                        }],
                        sentBy: 'recruiter',
                    }),
                ]);

                const employerRepId = _.get(campaign, 'senderUser.employerRepId');
                const { result: employerRep } = employerRepId
                    ? await EmployerRepService.getExistingEmployerRep(employerRepId)
                    : { result: null };

                if (_.isEmpty(templates)) {
                    if (channel === CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE) {
                        searchCtrl.showSideBar = 'contactCandidate';
                        searchCtrl.messageTemplates = [];
                    }

                    return;
                }

                const positionApprovalLink = _.get(positionApprovalLinkData, '0.link', null);
                const messageUuid = _.get(positionApprovalLinkData, '0.messageUuid');

                searchCtrl.templateRecruiterData = recruiter;
                searchCtrl.currentCandidate.positionApprovalLink = positionApprovalLink;

                if (
                    [
                        CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
                        CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL,
                        CONTACT_CHANNEL_TYPES.FACEBOOK,
                    ].includes(channel)
                ) {
                    searchCtrl.messageTemplates = searchCtrl
                        .searchData
                        .changeTemplateTags(
                            templates,
                            searchCtrl.currentCandidate,
                            searchCtrl.templateRecruiterData,
                            searchCtrl.searchData.positionData,
                            '',
                            channel,
                            employerRep,
                        );

                    searchCtrl.candidateToContact.msg = {};
                    searchCtrl.candidateToContact.msg.template = searchCtrl.messageTemplates[0];
                    searchCtrl.candidateToContact.msgContent = searchCtrl.candidateToContact.msg.template.template;
                    searchCtrl.candidateToContact.msg.messageUuid = messageUuid;

                    const candidateWebAdresses = _.get(
                        searchCtrl,
                        'candidateToContact.candidateData.contact.webAddress',
                        [],
                    );
                    searchCtrl.candidateLinkedin = _.find(candidateWebAdresses, { type: 'linkedin' });

                    const subject = _.get(searchCtrl, 'candidateToContact.msg.template.subject');

                    if (subject) {
                        searchCtrl.candidateToContact.msgSubject = subject;
                    }
                } else {
                    searchCtrl.emailTemplates = searchCtrl
                        .searchData
                        .changeTemplateTags(
                            templates,
                            searchCtrl.currentCandidate,
                            searchCtrl.templateRecruiterData,
                            searchCtrl.searchData.positionData,
                            '',
                            channel,
                            employerRep,
                        );

                    searchCtrl.candidateToContact.email = {};
                    searchCtrl.candidateToContact.email.template = searchCtrl.emailTemplates[0];
                    searchCtrl.candidateToContact.msgContent = searchCtrl.candidateToContact.email.template.template;
                    searchCtrl.candidateToContact.msgSubject = searchCtrl.candidateToContact.email.template.subject;
                }

                searchCtrl.showSideBar = 'contactCandidate';
            } catch (error) {
                logger.error(error);
            } finally {
                $scope.$apply();
            }
        };

        searchCtrl.deleteNote = (candidate, data, index) => {
            if (index >= 0) {
                searchCtrl
                    .currentCandidate
                    .notes = (searchCtrl.currentCandidate.notes || [])
                        .filter(item => item._id !== data._id);
            }

            CandidateService.deleteCandidateNote(candidate.workflow.candidateId, data._id);
        };

        searchCtrl.editNote = function (candidate, data, form) {
            if (form.$invalid) {
                return;
            }
            CandidateService
                .putCandidateNotes(candidate.workflow.candidateId, data._id, { content: data.noteEdit })
                .then(() => {
                    data.content = data.noteEdit;
                    data.showNoteEdit = false;
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.cleanMyJson = function (json) {
            for (let i = 0; i < json.educationHistory.length; i++) {
                delete json.educationHistory[i].educationDegreeFilter;
                delete json.educationHistory[i].educationHistoryFilter;
                delete json.educationHistory[i].monthsOfWork;
                if (json.educationHistory[i].degree && json.educationHistory[i].degree.constructor == Array) {
                    if (json.educationHistory[i].degree.length == 0) {
                        json.educationHistory[i].degree = {};
                        return;
                    }
                    json.educationHistory[i].degree = {
                        major: json.educationHistory[i].degree[0].value,
                        majorId: json.educationHistory[i].degree[0].uid,
                    };
                }
            }
        };

        searchCtrl.changeSearchFromMatch = function (fromMatch) {
            $sessionStorage.searchFromMatch = fromMatch;
            $state.go($state.current.name, {
                scroll: 0,
            }, { reload: $state.current.name });
        };

        searchCtrl.changeSearchFromPrediction = function (fromPrediction) {
            $sessionStorage.searchFromPrediction = fromPrediction;
            $state.go($state.current.name, {
                scroll: 0,
            }, { reload: $state.current.name });
        };

        searchCtrl.changeSearchTotalResultCount = (count) => {
            searchCacheService.clearSearchResults();
            $sessionStorage.searchResultTotalCount = count;

            $state.go($state.current.name, {
                scroll: 0,
                currCandidatePage: 1,
            }, { reload: $state.current.name });
        };

        searchCtrl.setSearchType = (type) => {
            searchCacheService.clearSearchResults();
            $sessionStorage.searchType = type;

            $state.go($state.current.name, {
                scroll: 0,
                currCandidatePage: 1,
            }, { reload: $state.current.name });
        };

        searchCtrl.approveSubmission = function (candidate, openCandidates, approveSubmission, expertObservations, contact) {
            candidate.moveToReadyBlockedObservations = false;
            candidate.moveToReadyBlockedEmailMissing = false;
            candidate.moveToReadyBlockedPhoneMissing = false;
            candidate.moveToReadyBlockedTelephoneMissing = false;
            candidate.moveToReadyBlockedContact = false;
            if ((!expertObservations || expertObservations == '') || ((!contact.emailAddress || contact.emailAddress.length == 0) && (!contact.mobile || contact.mobile.length == 0) && (!contact.telephone || contact.telephone.length == 0))) {
                searchCtrl.candidateTab = 'talent_for_employer';
                candidate.moveToReadyBlocked = true;
                NotificationService.error('APPROVE_SUBMISSION_ERROR_MISSING_REQUIRED_FIELDS');
                // if expert observation is null add a flag that tells us that
                if (!expertObservations || expertObservations == '') {
                    candidate.moveToReadyBlockedObservations = true;
                    searchCtrl.showPreferencesEditTalentForEmployer = true;
                }
                if ((!contact.emailAddress || contact.emailAddress.length == 0) &&
                    ((!contact.mobile || contact.mobile.length == 0) && (!contact.telephone || contact.telephone.length == 0))) {
                    searchCtrl.showTalentForEmployerApplicantDetailsEdit = true;
                    candidate.moveToReadyBlockedContact = true;
                    // if email is null add a flag that tells us that
                    if (!contact.emailAddress || contact.emailAddress.length == 0) {
                        candidate.moveToReadyBlockedEmailMissing = true;
                    }
                    // if phone is null add a flag that tells us that
                    if (!contact.mobile || contact.mobile.length == 0) {
                        candidate.moveToReadyBlockedPhoneMissing = true;
                    }
                    // if telephone is null add a flag that tells us that
                    if (!contact.telephone || contact.telephone.length == 0) {
                        candidate.moveToReadyBlockedTelephoneMissing = true;
                    }
                }
                return;
            }
            candidate.moveToReadyBlocked = false;
            searchCtrl
                .searchData
                .approveSubmission(candidate, openCandidates, approveSubmission);
        };

        searchCtrl.onSaveIntoPositionOptionClick = () => {
            ModalDialogService.showDialog({
                modalDialogId: 'saveIntoPositionModalDialog',
                title: 'SAVE_INTO_POSITION_HEADER',
                body: 'SAVE_INTO_POSITION_MESSAGE',
                showCancelButton: true,
                showCloseButton: true,
                onClose: () => {
                },
                buttons: [
                    {
                        label: 'SAVE_INTO_POSITION_CANCEL_YES',
                        className: 'primary-button',
                        onClick: () => searchCtrl.saveIntoPosition(),
                    },
                ],
            });

            searchCtrl.showPanelSetting = false;
        };

        searchCtrl.saveIntoPosition = function () {
            const selectedDesiredCandidateProfile = [];
            let lookAlikFilter = false;

            const cleanUpItems = items => _.map(items, (field) => {
                delete field.checked;
                delete field.sourceId;
                return field;
            });

            const getNewSelected = (field, items) => ({
                field,
                items: cleanUpItems(items),
            });

            for (let i = 0; i < searchCtrl.searchCriteriaFields.length; i++) {
                const currentItem = angular.copy(searchCtrl.searchCriteriaFields[i]);
                if (currentItem.selectedLookAlike) {
                    const newSelected = getNewSelected(currentItem.field, currentItem.selectedLookAlike);
                    selectedDesiredCandidateProfile.push(newSelected);
                    lookAlikFilter = true;
                }

                if (currentItem.minSelectedLookAlike) {
                    const newSelected = getNewSelected(currentItem.minField, currentItem.minSelectedLookAlike);
                    selectedDesiredCandidateProfile.push(newSelected);
                    lookAlikFilter = true;
                }
                if (currentItem.maxSelectedLookAlike) {
                    const newSelected = getNewSelected(currentItem.maxField, currentItem.maxSelectedLookAlike);
                    selectedDesiredCandidateProfile.push(newSelected);
                    lookAlikFilter = true;
                }
                if (lookAlikFilter == true) {
                    continue;
                }
                if (currentItem.selected && currentItem.selected.length > 0) {
                    const newSelected = {
                        field: currentItem.field,
                        items: currentItem.selected,
                    };
                    if (newSelected.field == 'locations' && newSelected.items.length > 0) {
                        const locationValue = newSelected.items[0].value;
                        const valueIsCoords = this.utils.isLocationString(locationValue);
                        if (!valueIsCoords) {
                            newSelected.items[0].value = '';
                        }
                    }

                    selectedDesiredCandidateProfile.push(newSelected);
                    continue;
                }
                if (currentItem.minSelected && currentItem.minSelected.length > 0) {
                    const newSelected = {
                        field: currentItem.minField,
                        items: currentItem.minSelected,
                    };
                    selectedDesiredCandidateProfile.push(newSelected);
                }
                if (currentItem.maxSelected && currentItem.maxSelected.length > 0) {
                    const newSelected = {
                        field: currentItem.maxField,
                        items: currentItem.maxSelected,
                    };
                    selectedDesiredCandidateProfile.push(newSelected);
                }
            }
            PositionService.addPosition({
                _id: searchCtrl.searchData.positionData._id,
                desiredCandidateProfile: {
                    maxItems: searchCtrl.searchData.positionData.desiredCandidateProfile.maxItems,
                    searchCountries: searchCtrl.searchData.positionData.desiredCandidateProfile.searchCountries,
                    searchLanguages: searchCtrl.searchData.positionData.desiredCandidateProfile.searchLanguages,
                    selected: selectedDesiredCandidateProfile,
                },
            }, true)
                .then(() => {
                    NotificationService.success('SAVE_INTO_POSITION_SUCCESS');
                    if ($sessionStorage.positionSearchName && $sessionStorage.positionSearchName.criteria) {
                        $sessionStorage.savedCandidateProfile = {
                            positionId: searchCtrl.searchData.positionData._id,
                            selected: angular.copy($sessionStorage.positionSearchName.criteria),
                        };
                    }
                    searchCtrl.savedCandidateProfile = $sessionStorage.savedCandidateProfile;
                    searchCtrl.searchData.positionData.desiredCandidateProfile.selected = angular.copy(selectedDesiredCandidateProfile);
                    searchCtrl.searchName = $sessionStorage.positionSearchName.name;
                    searchCtrl.searchCriteria.name = $sessionStorage.positionSearchName.name;
                    searchCtrl.searchCriteriaFields = _.map(angular.copy(searchCtrl.searchCriteriaFields), (field) => {
                        if (field.selectedLookAlike) {
                            field.selected = _.map(field.selectedLookAlike, (item) => {
                                delete item.status;
                                delete item.reason;
                                return item;
                            });
                        }
                        if (field.minSelectedLookAlike) {
                            field.minSelected = _.map(field.minSelectedLookAlike, (item) => {
                                delete item.status;
                                delete item.reason;
                                return item;
                            });
                        }
                        if (field.maxSelectedLookAlike) {
                            field.maxSelected = _.map(field.maxSelectedLookAlike, (item) => {
                                delete item.status;
                                delete item.reason;
                                return item;
                            });
                        }
                        delete field.selectedLookAlike;
                        delete field.minSelectedLookAlike;
                        delete field.maxSelectedLookAlike;
                        return field;
                    });
                    $sessionStorage.positionSearchName.criteria = angular.copy(searchCtrl.searchCriteriaFields);
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.openRestoreLastPositionModal = function () {
            if (searchCtrl.savedCandidateProfile) {
                searchCtrl.modalDialogView = 'restoreFromPosition.html';
                searchCtrl.openModalDialog({});
            }
        };

        searchCtrl.restoreLastPosition = function () {
            const selected = [];
            for (let i = 0; i < searchCtrl.savedCandidateProfile.selected.length; i++) {
                if (searchCtrl.savedCandidateProfile.selected[i].selected && searchCtrl.savedCandidateProfile.selected[i].selected.length > 0) {
                    const newSelected = {
                        field: searchCtrl.savedCandidateProfile.selected[i].field,
                        items: searchCtrl.savedCandidateProfile.selected[i].selected,
                    };
                    selected.push(newSelected);
                    continue;
                }
                if (searchCtrl.savedCandidateProfile.selected[i].minSelected && searchCtrl.savedCandidateProfile.selected[i].minSelected.length > 0) {
                    const newSelected = {
                        field: searchCtrl.savedCandidateProfile.selected[i].minField,
                        items: searchCtrl.savedCandidateProfile.selected[i].minSelected,
                    };
                    selected.push(newSelected);
                }
                if (searchCtrl.savedCandidateProfile.selected[i].maxSelected && searchCtrl.savedCandidateProfile.selected[i].maxSelected.length > 0) {
                    const newSelected = {
                        field: searchCtrl.savedCandidateProfile.selected[i].maxField,
                        items: searchCtrl.savedCandidateProfile.selected[i].maxSelected,
                    };
                    selected.push(newSelected);
                }
            }
            PositionService.addPosition({
                _id: searchCtrl.searchData.positionData._id,
                desiredCandidateProfile: {
                    maxItems: searchCtrl.searchData.positionData.desiredCandidateProfile.maxItems,
                    searchCountries: searchCtrl.searchData.positionData.desiredCandidateProfile.searchCountries,
                    searchLanguages: searchCtrl.searchData.positionData.desiredCandidateProfile.searchLanguages,
                    selected,
                },
            }, true)
                .then(() => {
                    NotificationService.success('RESTORE_LAST_POSITION_SUCCESS');
                    $sessionStorage.positionSearchName.criteria = angular.copy(searchCtrl.savedCandidateProfile.selected);
                    searchCtrl.searchName = $sessionStorage.positionSearchName.name;
                    searchCtrl.searchData.positionData.desiredCandidateProfile.selected = angular.copy(selected);
                    searchCtrl.searchCriteriaFields = angular.copy(searchCtrl.savedCandidateProfile.selected);
                    $sessionStorage.savedCandidateProfile = null;
                    searchCtrl.savedCandidateProfile = null;
                })
                .catch(err => logger.error(err));
            searchCtrl.closeModalDialog();
        };

        searchCtrl.updateCriteriaWithNewFilter = function (criteria, updatedQueryItem, explains) {
            if (criteria.required === updatedQueryItem.required) {
                if (criteria.additional && updatedQueryItem.additional || !criteria.additional && !updatedQueryItem.additional) {
                    if (criteria.additional && criteria.additional.uid !== updatedQueryItem.additional.uid) {
                        criteria.status = 'updated';
                    } else {
                        criteria.status = 'no-change';
                    }
                } else {
                    criteria.status = 'updated';
                }
            } else {
                criteria.required = updatedQueryItem.required;
                criteria.status = 'updated';
            }

            if (criteria.status === 'updated') {
                const explain = _.find(explains, { id: updatedQueryItem.sourceId });

                if (explain) {
                    criteria.reason = explain.action;
                }
            }

            updatedQueryItem.checked = true;
        };

        searchCtrl.sendToEmployerButtonClick = function () {
            if ((searchCtrl.talenyaUser) || (!searchCtrl.talenyaUser && searchCtrl.canSendToEmployer)) {
                RecruiterService
                    .getRecruiter(searchCtrl.searchData.recruiterId)
                    .then((response) => {
                        searchCtrl.recruiterData = response.result;
                        let language = RouteService.getUserPreference('uiLanguage');
                        if (!language) {
                            language = 'en-US';
                        }
                        RouteService
                            .getEmailTemplates(language, 'profileEmployer')
                            .then((response) => {
                                searchCtrl.contactUserTemplates = [];
                                searchCtrl.userData = {
                                    positionData: searchCtrl.searchData.positionData,
                                    candidateData: searchCtrl.currentCandidate,
                                    emailType: 'employer',
                                };
                                if (response.result && response.result.templates) {
                                    searchCtrl.contactUserTemplates = searchCtrl
                                        .searchData
                                        .changeTemplateTags(
                                            response.result.templates,
                                            searchCtrl.currentCandidate,
                                            searchCtrl.recruiterData,
                                            searchCtrl.searchData.positionData,
                                            response.result.type,
                                        );
                                }
                                searchCtrl.showSideBar = 'sendResumeToEmployer';
                            });
                    })
                    .catch(err => logger.error(err));
            }
        };

        searchCtrl.sendToCandidateButtonClick = function () {
            RecruiterService
                .getRecruiter(searchCtrl.searchData.recruiterId)
                .then((response) => {
                    searchCtrl.recruiterData = response.result;
                    let language = RouteService.getUserPreference('uiLanguage');
                    if (!language) {
                        language = 'en-US';
                    }
                    RouteService
                        .getEmailTemplates(language, 'profileCandidate')
                        .then((response) => {
                            searchCtrl.contactUserTemplates = [];
                            searchCtrl.userData = {
                                positionData: searchCtrl.searchData.positionData,
                                candidateData: searchCtrl.currentCandidate,
                            };
                            if (response.result && response.result.templates) {
                                if (searchCtrl.talentRecord && searchCtrl.talentRecord.candidateData && searchCtrl.talentRecord.candidateData._id) {
                                    searchCtrl.currentCandidate.talentForCandidateId = searchCtrl.talentRecord.candidateData._id;
                                }
                                searchCtrl.contactUserTemplates = searchCtrl
                                    .searchData
                                    .changeTemplateTags(
                                        response.result.templates,
                                        searchCtrl.currentCandidate,
                                        searchCtrl.recruiterData,
                                        searchCtrl.searchData.positionData,
                                        response.result.type,
                                    );
                            }
                            searchCtrl.showSideBar = 'sendResumeToCandidate';
                        })
                        .catch(err => logger.error(err));
                })
                .catch(err => logger.error(err));
        };

        searchCtrl.closeContactMode = () => {
            searchCtrl.contactMode = null;
        };

        searchCtrl.setContactMode = (candidate, channel) => {
            searchCtrl.candidateToContact = candidate;
            searchCtrl.candidateToContact.contactCandidateOutcome = null;

            searchCtrl.contactMode = channel;

            searchCtrl.initContactCandidate(channel);
        };

        searchCtrl.messageModeInit = function (candidate) {
            searchCtrl.setContactMode(candidate, CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE);
        };

        searchCtrl.getEmployerStatus = () => {
            const currentCandidateWorkFlow = searchCtrl.currentCandidate.workflow;

            if (currentCandidateWorkFlow) {
                const employerStatus = currentCandidateWorkFlow.employerStatus;

                if (employerStatus && employerStatus.history && employerStatus.history[0]) {
                    const firstHistoryRecord = employerStatus.history[0];

                    return firstHistoryRecord && firstHistoryRecord.status;
                }
            }

            return null;
        };

        searchCtrl.setEmployerShowNameVisibilityState = () => {
            // TODO fixme according new employer flow
            const isWorkFlowStatusProspect = searchCtrl.searchData.workFlowStatus === EMPLOYER_WORKFLOW_STATUS.REVIEWED;
            const isWorkFlowStatusRejected = searchCtrl.searchData.workFlowStatus === EMPLOYER_WORKFLOW_STATUS.REJECTED;
            const employerStatus = searchCtrl.getEmployerStatus();

            if (employerStatus) {
                const isEmployerStatusProspect = employerStatus === EMPLOYER_WORKFLOW_STATUS.REVIEWED;
                const isEmployerCandidateNameNotVisible = isWorkFlowStatusProspect || (isWorkFlowStatusRejected && isEmployerStatusProspect);

                searchCtrl.isEmployerCandidateNameVisible = !isEmployerCandidateNameNotVisible;
            } else {
                searchCtrl.isEmployerCandidateNameVisible = false;
            }

            const isSourceServices = searchCtrl.searchData.positionData.employerContactCandidates;
            if (isSourceServices) {
                searchCtrl.isEmployerCandidateDetailsVisible = true;
                searchCtrl.isEmployerCandidateNameVisible = true;
            } else {
                searchCtrl.isEmployerCandidateDetailsVisible = true;
                searchCtrl.isEmployerCandidateNameVisible = false;
            }
        };

        searchCtrl.openEditMode = function (enableEdit, editView, idx) {
            searchCtrl.formToEdit = enableEdit;
            if (searchCtrl.currentCandidate.workflow.employerStatus.current === EMPLOYER_WORKFLOW_STATUS.REVIEWED) {
                const data = {
                    editView,
                    formIndexToEdit: idx,
                };
                searchCtrl.openModalDialog(data);
            } else {
                searchCtrl.enableFormToEdit(idx);
            }
        };

        searchCtrl.enableFormToEdit = function (idx) {
            switch (searchCtrl.formToEdit) {
                case 'candDetails':
                    searchCtrl.showTalentForEmployerApplicantDetailsEdit = true;
                    break;
                case 'residencyDetails':
                    searchCtrl.showTalentResidency = true;
                    break;
                case 'expertObservation':
                    searchCtrl.showPreferencesEditTalentForEmployer = true;
                    break;
                case 'candidateName':
                    searchCtrl.showCandidateNameEditTalentForEmployer = true;
                    break;
                case 'summary':
                    searchCtrl.showSummaryTalentForEmployer = true;
                    break;
                case 'experience':
                    searchCtrl.talentRecord.candidateData.employmentHistory[idx].showEditTalentForEmployer = true;
                    break;
                case 'education':
                    searchCtrl.talentRecord.candidateData.educationHistory[idx].showEditTalentForEmployer = true;
                    break;
                case 'language':
                    searchCtrl.openEditLanguages = true;
                    break;
                case 'skills':
                    searchCtrl.openEditSkills = true;
                    break;
                default:
                    break;
            }
        };
    }

    async onProfileSkillsChanged(skills) {
        const preparedSkills = this.prepareSkills(skills);

        await this.TalentService.putTalent(this.currentCandidate.talentID, { skills: preparedSkills });
        this.currentCandidate.candidateData.skills = preparedSkills;
        this.$scope.$digest();
    }

    async onTalentForEmployerSkillsChanged(skills) {
        let talentData = this.copyTalentForEmployer();
        talentData.skills = this.prepareSkills(skills);
        talentData = this.normalizeContactData(talentData);

        try {
            await this.serviceUpdateTalent(this.talentRecord.candidateData._id, talentData);
            const { result: talent } = await this.TalentService.getTalent(this.currentCandidate.talentID);
            this.currentCandidate.candidateData.skills = talent.skills;
        } catch (error) {
            logger.error(error);
        }
    }

    async onPreferencesChanged(preferences) {
        const { $timeout } = this;

        try {
            await this.TalentService.putTalent(this.currentCandidate.talentID, { preferences });

            $timeout(() => this.currentCandidate.candidateData.preferences = preferences);
        } catch (error) {
            logger.error(error);
        }
    }

    async onTalentForEmployerPreferencesChanged(preferences) {
        const talentData = {
            ...this.normalizeContactData(this.copyTalentForEmployer()),
            preferences,
        };

        try {
            await this.serviceUpdateTalent(this.talentRecord.candidateData._id, talentData, 'showPreferencesEditTalentForEmployer');
        } catch (error) {
            logger.error(error);
        }
    }

    normalizeContactData(inputTalentData) {
        const talentData = angular.copy(inputTalentData);

        if (talentData.contact) {
            _.remove(talentData.contact.webAddress, webAddress => webAddress.url === '' || webAddress.url == null);
            _.remove(talentData.contact.regularWebsites, webAddress => webAddress.url === '' || webAddress.url == null);
            _.remove(talentData.contact.emailAddress, emailAddress => emailAddress.value === '' || emailAddress.value == null);
            _.remove(talentData.contact.mobile, mobile => mobile.value === '' || mobile.value == null);
            _.remove(talentData.contact.telephone, telephone => telephone.value === '' || telephone.value == null);

            talentData.contact.webAddress = talentData
                .contact
                .webAddress
                .concat(talentData.contact.regularWebsites);
            talentData.contact.emailAddress = _.map(talentData.contact.emailAddress, 'value');
            talentData.contact.mobile = _.map(talentData.contact.mobile, 'value');
            talentData.contact.fax = _.map(talentData.contact.fax, 'value');
            talentData.contact.telephone = _.map(talentData.contact.telephone, 'value');
        }

        return talentData;
    }

    prepareSkills(skills = {}) {
        return (skills.selected || []).map(value => ({
            skillId: value.uid,
            skillName: value.value,
            isDerived: value.isDerived,
        }));
    }

    setupEditTalentForEmployerSkillsState() {
        const currentRecruiterId = this.currentCandidate.workflow.recruiterId;
        const currentRecruiterStatus = this.currentCandidate.workflow.recruiterStatus.current;
        const currentEmployerStatus = this.currentCandidate.workflow.employerStatus.current;

        this.canEditTalentForEmployerSkills =
            this.getEditTalentForEmployerSkillsState(currentRecruiterId, currentRecruiterStatus, currentEmployerStatus);
    }

    getEditTalentForEmployerSkillsState(currentRecruiterId, currentRecruiterStatus, currentEmployerStatus) {
        const isNotHiddenStatus = ['Hidden', 'Rejected', 'Hired'].indexOf(currentRecruiterStatus) < 0;
        const isProspectStatus = ['None', 'Prospect'].indexOf(currentEmployerStatus) >= 0;

        return isNotHiddenStatus && isProspectStatus;
    }

    sendMessageToCandidate(candidate, message, summary, selectedMessage) {
        return this.searchData.sendLinkedinMessageToCandidate(
            {
                ...candidate,
                msgContent: message,
                checkLinkedin: true,
            },
            summary,
            selectedMessage,
        );
    }

    sendEmailToCandidate(candidate, email, emailAddresses, selectedMessage) {
        return this.sendMsg({
            candidate,
            openCandidates: null,
            contactCandidate: email,
            type: 'email',
            email: emailAddresses,
            needToBeReloaded: false,
            flowType: 'contactCandidate',
            selectedMessage,
        });
    }

    sendLinkedinInmail(candidate, email, emailAddresses, selectedMessage) {
        const emailData = {
            msgContent: email.template,
            msgSubject: email.subject,
        };
        this.sendMsg({
            candidate,
            openCandidates: null,
            contactCandidate: emailData,
            type: 'inmail',
            email: emailAddresses,
            needToBeReloaded: false,
            flowType: 'contactCandidate',
            selectedMessage,
        });
    }

    getSelectedCandidates() {
        const selectedCandidates = [];
        const { currentPage, candidatesPerPage, filteredCandidates } = this;

        for (let i = (currentPage - 1) * candidatesPerPage; i < currentPage * candidatesPerPage; i++) {
            if (i >= filteredCandidates.resultListLength || i < 0) {
                break;
            }
            const element = filteredCandidates.resultList[i];
            if (element && element.check) {
                selectedCandidates.push(element);
            }
        }

        return selectedCandidates;
    }

    multiContactCandidates() {
        this.selectedCandidates = this.getSelectedCandidates();
        this.modalDialogView = 'batch/template.html';
        this.openModalDialog();
    }

    multiContactCandidateAbort() {
        this.NotificationService.success('BULK_SEND_ABORTED');
        window.onbeforeunload = null;
        this.bulkModeActive = false;
        this.closeModalDialog();
    }

    multiContactCandidatesDone() {
        this.closeModalDialog();
        this.refreshContactChannelData();
    }

    async backToCandidates() {
        const {
            $state,
            $stateParams,
            $sessionStorage: {
                previousState,
            },
            searchData: {
                recruiterId,
                positionData: {
                    _id: positionId,
                },
            },
            RecruiterWorkflowStepResolver,
        } = this;

        if (this.$state.is('employer.search')) {
            this.WebAppRouteService.goToViewJobPage($stateParams);

            return;
        }

        if (previousState && previousState.state.indexOf('search') < 0) {
            $state.go(previousState.state, previousState.params);
        } else {
            const workflowStep = await RecruiterWorkflowStepResolver.getWorkflowStep(positionId, recruiterId);

            $state.go('recruiter.candidatesJob', {
                positionId,
                scroll: 0,
                currCandidatePage: 1,
                candidate: null,
                workflowStep,
            });
        }
    }

    async multiRequestFeedback() {
        const selectedCandidates = this.getSelectedCandidates();

        try {
            await this.searchData.multiRequestFeedback(selectedCandidates);
        } catch (error) {
            logger.error(error);
        } finally {
            this.unCheckAll();
        }
    }

    async multiBackToProspect() {
        const candidates = this.getSelectedCandidates();

        if (candidates.length > 0) {
            $('#recruiterModalDialog')
                .modal('hide');

            await this
                .searchData
                .multiBackToProspect(candidates, this.openCandidates);
        }
    }

    multiRejectsModal() {
        this.modalDialogView = 'multiRejectView.html';
        const haveGoodRatedCandidates = this.getGoodRatedCandidates().length > 0;
        const modalData = {
            haveGoodRatedCandidates,
        };

        this.openModalDialog(modalData);
    }

    createRequestForSearchALike({ deriveJobTitles = false } = {}) {
        const cascadingSearch = _.get(this, 'searchType', searchTypes.LEGACY) === searchTypes.CASCADING;
        const searchRequest = {
            searchCountries: ['1234', '9876', '5555'].map(code => ({ code })),
            searchLanguages: [
                {
                    code: '1234',
                },
            ],
            maxItems: this.searchData.showResults || this.numberOfCandidatesToSearch || 400,
            cascadingSearch,
            selected: [],
        };

        for (let i = 0; i < this.searchCriteriaFields.length; i++) {
            const searchCriteriaField = this.searchCriteriaFields[i];

            if (searchCriteriaField.selectedLookAlike && searchCriteriaField.selectedLookAlike.length > 0) {
                const newSelected = {
                    field: searchCriteriaField.field,
                    items: searchCriteriaField.selectedLookAlike,
                };

                searchRequest
                    .selected
                    .push(newSelected);
                continue;
            }

            if (searchCriteriaField.selected && searchCriteriaField.selected.length > 0) {
                const newSelected = {
                    field: searchCriteriaField.field,
                    items: searchCriteriaField.selected,
                };

                searchRequest
                    .selected
                    .push(newSelected);
                continue;
            }

            if (searchCriteriaField.minSelected && searchCriteriaField.minSelected.length > 0) {
                const newSelected = {
                    field: searchCriteriaField.minField,
                    items: searchCriteriaField.minSelected,
                };

                searchRequest
                    .selected
                    .push(newSelected);
            }

            if (searchCriteriaField.maxSelected && searchCriteriaField.maxSelected.length > 0) {
                const newSelected = {
                    field: searchCriteriaField.maxField,
                    items: searchCriteriaField.maxSelected,
                };

                searchRequest
                    .selected
                    .push(newSelected);
            }
        }

        return {
            deriveJobTitles,
            filter: searchRequest,
        };
    }

    buildSearchCriteriaForALike(searchALikeResult, staticDataDictionary) {
        const { result: { explains, selected } } = searchALikeResult;
        const updatedQuery = selected;
        const updatedQueryCriteriaTemp = {};

        this.$sessionStorage.searchExplainScore = explains;

        this.searchCriteriaFields = _.map(angular.copy(this.searchCriteriaFields), (criteria) => {
            if (criteria.field) {
                const updatedQueryCriteria = _.find(updatedQuery, { field: criteria.field });

                if (updatedQueryCriteria) {
                    for (let i = 0; i < updatedQueryCriteria.items.length; i++) {
                        const updatedCriteriaItem = updatedQueryCriteria.items[i];

                        const needFullfilSubCriteria = updatedCriteriaItem.additional
                            && !updatedCriteriaItem.additional.value
                            && criteria.type === 'dynamic';

                        if (needFullfilSubCriteria) {
                            const staticData = staticDataDictionary[criteria.subCriteria.lookupData];
                            const field = updatedCriteriaItem.additional.uid;
                            const staticField = _.find(staticData, { id: field });
                            if (staticField) {
                                updatedCriteriaItem.additional.value = staticField.text;
                            }
                        }

                        if (!updatedCriteriaItem.value && criteria.type === 'static') {
                            updatedQueryCriteriaTemp[updatedCriteriaItem.uid] = updatedCriteriaItem;

                            const staticData = staticDataDictionary[criteria.lookupData];
                            const field = updatedCriteriaItem.uid;
                            const staticField = _.find(staticData, { id: updatedQueryCriteriaTemp[field].uid });

                            if (staticField) {
                                updatedQueryCriteriaTemp[field].value = angular.copy(staticField.text);
                            }

                            if (criteria.subCriteria) {
                                const additionalStaticData = staticDataDictionary[criteria.subCriteria.lookupData];
                                const additionalField = updatedCriteriaItem.additional.uid;
                                const staticAdditionalField = _.find(additionalStaticData, { id: additionalField });

                                if (staticAdditionalField) {
                                    updatedQueryCriteriaTemp[field].additional.value = angular.copy(staticAdditionalField.text);
                                }
                            }
                        }

                        let foundCriteria = null;

                        if (updatedCriteriaItem.group) {
                            const groupValue = (updatedCriteriaItem.group || []).map(({ value }) => value).join(',');

                            foundCriteria = (criteria.selected || []).find((item) => {
                                if (item.group) {
                                    const itemGroupValue = (item.group || []).map(({ value }) => value).join(',');

                                    return itemGroupValue === groupValue;
                                }

                                return false;
                            });
                        } else {
                            foundCriteria = _.find(criteria.selected, { value: updatedCriteriaItem.value });
                        }

                        if (foundCriteria) {
                            this.updateCriteriaWithNewFilter(foundCriteria, updatedCriteriaItem, explains);
                        } else {
                            updatedCriteriaItem.status = 'new';
                            updatedCriteriaItem.reason = 'NEW';
                            criteria
                                .selected
                                .push(updatedCriteriaItem);
                        }
                    }
                }

                criteria.selectedLookAlike = updatedQueryCriteria && updatedQueryCriteria.items || [];
                criteria.selected = _.map(criteria.selected, (subCriteria) => {
                    const changeAdditionalLookAlike = _.find(criteria.selectedLookAlike, { value: subCriteria.value });

                    if (changeAdditionalLookAlike) {
                        changeAdditionalLookAlike.additional = subCriteria.additional;
                    }

                    if (!subCriteria.status) {
                        subCriteria.status = 'deleted';
                    }

                    return subCriteria;
                });
            } else {
                const isYearsOfExpiarenceCriteria = criteria.minField === 'yearsOfExperience';
                let updatdedQueryCriteria = _.find(updatedQuery, { field: criteria.minField });
                let criteriaLookupField = criteria.minField;

                if (criteria.minField === 'minimalSeniority') {
                    criteriaLookupField = 'seniority';
                }

                const staticData = staticDataDictionary[criteriaLookupField];

                if (updatdedQueryCriteria) {
                    (updatdedQueryCriteria.items || []).forEach((item) => {
                        const staticField = _.find(staticData, { id: item.uid.toString() });

                        if (staticField) {
                            item.value = angular.copy(staticField.text);
                        }
                    });

                    for (let i = 0; i < updatdedQueryCriteria.items.length; i++) {
                        const foundCrieria = _.find(criteria.minSelected, { uid: updatdedQueryCriteria.items[i].uid.toString() });

                        if (foundCrieria) {
                            this.updateCriteriaWithNewFilter(foundCrieria, updatdedQueryCriteria.items[i], explains);
                        } else {
                            updatdedQueryCriteria.items[i].status = 'new';
                            updatdedQueryCriteria.items[i].reason = 'NEW';
                            criteria.minSelected = [updatdedQueryCriteria.items[i]];
                        }
                    }
                    criteria.minSelectedLookAlike = updatdedQueryCriteria && updatdedQueryCriteria.items || [];
                }

                updatdedQueryCriteria = _.find(updatedQuery, { field: criteria.maxField });

                if (updatdedQueryCriteria) {
                    (updatdedQueryCriteria.items || []).forEach((item) => {
                        const staticField = _.find(staticData, { id: item.uid.toString() });

                        if (staticField) {
                            item.value = angular.copy(staticField.text);
                        } else if (isYearsOfExpiarenceCriteria && item.uid) {
                            const biggestExpiarence = staticData[staticData.length - 1];

                            item.value = biggestExpiarence.text;
                        }
                    });

                    for (let i = 0; i < updatdedQueryCriteria.items.length; i++) {
                        const foundCrieria = _.find(criteria.maxSelected, { uid: updatdedQueryCriteria.items[i].uid.toString() });

                        if (foundCrieria) {
                            this.updateCriteriaWithNewFilter(foundCrieria, updatdedQueryCriteria.items[i], explains);
                        } else {
                            updatdedQueryCriteria.items[i].status = 'new';
                            updatdedQueryCriteria.items[i].reason = 'NEW';
                            criteria.maxSelected = [updatdedQueryCriteria.items[i]];
                        }
                    }
                    criteria.maxSelectedLookAlike = updatdedQueryCriteria && updatdedQueryCriteria.items || [];
                }

                criteria.minSelected = _.map(criteria.minSelected, (subCriteria) => {
                    const changeAdditionalLookAlike = _.find(criteria.minSelectedLookAlike, { uid: subCriteria.uid.toString() });

                    if (changeAdditionalLookAlike) {
                        changeAdditionalLookAlike.additional = subCriteria.additional;
                    }

                    if (!subCriteria.status) {
                        subCriteria.status = 'deleted';
                    }

                    return subCriteria;
                });

                criteria.maxSelected = _.map(criteria.maxSelected, (subCriteria) => {
                    const changeAdditionalLookAlike = _.find(criteria.maxSelectedLookAlike, { uid: subCriteria.uid.toString() });

                    if (changeAdditionalLookAlike) {
                        changeAdditionalLookAlike.additional = subCriteria.additional;
                    }

                    if (!subCriteria.status) {
                        subCriteria.status = 'deleted';
                    }

                    return subCriteria;
                });
            }
            return criteria;
        });
    }

    getCandidatesByRatingPredicate(predicate) {
        const candidates = this.getSelectedCandidates();

        return candidates.filter((candidate) => {
            const grade = _.get(candidate, 'workflow.feedback.grades.0.grade', 0);
            return predicate(grade);
        });
    }

    getBadRatedCandidates() {
        return this.getCandidatesByRatingPredicate(grade => grade < this.DOMAIN_CONFIG.MIN_SUCCESS_GRADE);
    }

    getGoodRatedCandidates() {
        return this.getCandidatesByRatingPredicate(grade => grade >= this.DOMAIN_CONFIG.MIN_SUCCESS_GRADE);
    }

    multiRejectAllCandidates() {
        const candidates = this.getSelectedCandidates();

        if (candidates.length > 0) {
            this.searchData.multiRejectCandidates(candidates);
        }

        $('#recruiterModalDialog')
            .modal('hide');
    }

    async searchByLookAlike({ deriveJobTitles = false } = {}) {
        try {
            this.searchName = deriveJobTitles ? this.$filter('translate')('LOOK_ALIKE_CLAIMED_DERIVED_TITLES') : this.$filter('translate')('LOOK_ALIKE_CLAIMED');
            const searchALikeRequest = this.createRequestForSearchALike({ deriveJobTitles });

            const positionId = this.searchData.positionId;
            const { result: workflowSearchResponse } = await this.WorkflowService.getWorkflowSearch({
                positionId,
                recruiterId: this.searchData.recruiterId,
            });
            const inClaimed = name => ['Prospect', 'Rejected', 'Hidden'].indexOf(name) < 0;
            const onlyClaimed = _.filter(workflowSearchResponse, ({ recruiterStatus: { current } }) => inClaimed(current));
            const positiveTalentIds = _.map(onlyClaimed, 'talentId');

            const searchALikeBody = Object.assign({}, searchALikeRequest, { positiveTalentIds });
            const searchALikeResult = await this.TalentScoreService.getSearchExplainScore(positionId, searchALikeBody);

            const hasChanges = _.get(searchALikeResult, 'result.explains.0.boostNetChanges');

            if (!hasChanges) {
                this.NotificationService.warning('SEARCH_LOOK_ALIKE_NO_CHANGE');
            } else {
                await this.makeALikeSearch(searchALikeResult);
            }

            this.$scope.$apply();
        } catch (err) {
            logger.error(err);
        }
    }

    async makeALikeSearch(searchALikeResult) {
        const staticDataDictionary = await this.StaticDataService.getStaticDataDictionary();

        this.buildSearchCriteriaForALike(searchALikeResult, staticDataDictionary);
    }

    async searchByFeedbackAlike({ deriveJobTitles = false } = {}) {
        try {
            this.searchName = deriveJobTitles ? this.$filter('translate')('LOOK_ALIKE_FEEDBACK_DERIVED_TITLES') : this.$filter('translate')('LOOK_ALIKE_FEEDBACK');
            const searchALikeRequest = this.createRequestForSearchALike({ deriveJobTitles });
            const searchALikeResult = await this.TalentScoreService.searchFeedbackALikePriorities({
                body: searchALikeRequest,
                positionId: this.searchData.positionId,
            });

            const hasChanges = _.get(searchALikeResult, 'result.explains.0.boostNetChanges');

            if (!hasChanges) {
                this.NotificationService.warning('SEARCH_LOOK_ALIKE_NO_CHANGE');
            } else {
                await this.makeALikeSearch(searchALikeResult);
            }

            this.$scope.$apply();
        } catch (err) {
            logger.error(err);
        }
    }

    async checkIfSearchByLookAlike() {
        this.canSearchByLookAlike = false;
        try {
            const { result: workflowSearchResponse = [] } = await this.WorkflowService.getWorkflowSearch({
                positionId: this.searchData.positionId,
                recruiterId: this.searchData.recruiterId,
            }) || {};
            let claimedTalents = 0;
            for (let i = 0; i < workflowSearchResponse.length; i++) {
                if (['Claimed'].indexOf(workflowSearchResponse[i].recruiterStatus.current) > -1) {
                    claimedTalents++;
                }
            }
            this.$timeout(() => this.canSearchByLookAlike = claimedTalents > 0, 200);
        } catch (err) {
            logger.error(err);
        }
    }

    async checkIfSearchByFeedbackAlike() {
        this.canSearchByFeedbackAlike = false;
        try {
            const { result: canSearch } = await this.TalentScoreService.canSearchFeedbackALike({ positionId: this.searchData.positionId });

            this.$timeout(() => this.canSearchByFeedbackAlike = canSearch);
        } catch (err) {
            logger.error(err);
        }
    }

    multiRejectNonPositiveCandidates() {
        const candidates = this.getBadRatedCandidates();

        if (candidates.length > 0) {
            this.searchData.multiRejectCandidates(candidates);
        }

        $('#recruiterModalDialog')
            .modal('hide');
    }

    initContactData() {
        const { $scope } = this;

        $scope.emailData = {
            emails: (_.get(this, 'currentCandidate.candidateData.contact.emailAddress', []) || []).map(value => ({ value })),
            selected: [],
        };

        this.emailOrLinkeError = false;
        this.emptyEmail = false;
    }

    sendResume() {
        const { $scope } = this;
        const selectedEmails = _.get($scope, 'emailData.selected', []).map(({ value }) => value);

        this.sendMsg({
            candidate: this.currentCandidate,
            openCandidates: null,
            contactCandidate: this.candidateToContact,
            type: CONTACT_CHANNEL_TYPES.EMAIL,
            email: selectedEmails,
            needToBeReloaded: true,
            flowType: 'contactCandidate',
        });
    }

    confirmResponse(contactCandidate) {
        this.sendMsg({
            candidate: this.currentCandidate,
            openCandidates: this.openCandidates,
            contactCandidate,
            type: 'response',
            email: null,
            needToBeReloaded: true,
            flowType: 'contactCandidate',
        });
    }

    contactViaFacebook(selectedEmailData) {
        this.sendMsg({
            candidate: this.currentCandidate,
            openCandidates: null,
            contactCandidate: this.candidateToContact,
            type: CONTACT_CHANNEL_TYPES.FACEBOOK,
            email: selectedEmailData,
            needToBeReloaded: true,
            flowType: 'contactCandidate',
        });
    }

    contactLinkedinInmail(selectedEmailData) {
        this.sendMsg({
            candidate: this.currentCandidate,
            openCandidates: null,
            contactCandidate: this.candidateToContact,
            type: CONTACT_CHANNEL_TYPES.LINKEDIN_INMAIL,
            email: selectedEmailData,
            needToBeReloaded: true,
            flowType: 'contactCandidate',
        });
    }

    contactLinkedin(selectedEmailData) {
        this.sendMsg({
            candidate: this.currentCandidate,
            openCandidates: null,
            contactCandidate: this.candidateToContact,
            type: CONTACT_CHANNEL_TYPES.LINKEDIN_MESSAGE,
            email: selectedEmailData,
            needToBeReloaded: true,
            flowType: 'contactCandidate',
        });
    }

    getSearchRequest(isSearchPage) {
        const maxItems = _.get(this.searchResultTotalCount, 'value', 400);
        const cascadingSearch = _.get(this, 'searchType', searchTypes.LEGACY) === searchTypes.CASCADING || !isSearchPage;

        if (!isSearchPage) {
            return { maxItems, cascadingSearch };
        }

        const searchRequest = {
            searchCountries: [{ code: '1234' }, { code: '9876' }, { code: '5555' }],
            searchLanguages: [{ code: '1234' }],
            maxItems,
            cascadingSearch,
            selected: [],
            kpis: this.talentScoreKPIs,
        };

        if (this.searchFromMatch && this.searchFromPrediction) {
            searchRequest.totalTalentPoolThresholds = {
                score: { min: this.searchFromMatch.value },
                prediction: { min: this.searchFromPrediction.value },
            };
        }

        const cleanUpFields = fields => _.map(fields, (field) => {
            delete field.checked;
            delete field.sourceId;
            return field;
        });
        searchRequest.selected = (this.searchCriteriaFields || []).reduce((selected, searchCriteriaField) => {
            const lookAlikeFilter =
                searchCriteriaField.selectedLookAlike ||
                searchCriteriaField.minSelectedLookAlike ||
                searchCriteriaField.maxSelectedLookAlike;

            if (_.get(searchCriteriaField, 'selectedLookAlike.length', 0)) {
                selected.push({
                    field: searchCriteriaField.field,
                    items: cleanUpFields(searchCriteriaField.selectedLookAlike),
                });
            }

            if (_.get(searchCriteriaField, 'minSelectedLookAlike.length', 0)) {
                selected.push({
                    field: searchCriteriaField.minField,
                    items: cleanUpFields(searchCriteriaField.minSelectedLookAlike),
                });
            }

            if (_.get(searchCriteriaField, 'maxSelectedLookAlike.length', 0)) {
                selected.push({
                    field: searchCriteriaField.maxField,
                    items: cleanUpFields(searchCriteriaField.maxSelectedLookAlike),
                });
            }

            if (lookAlikeFilter) {
                return selected;
            }

            if (_.get(searchCriteriaField, 'selected.length', 0)) {
                selected.push({
                    field: searchCriteriaField.field,
                    items: searchCriteriaField.selected,
                });

                return selected;
            }

            if (_.get(searchCriteriaField, 'minSelected.length', 0)) {
                selected.push({
                    field: searchCriteriaField.minField,
                    items: searchCriteriaField.minSelected,
                });
            }
            if (_.get(searchCriteriaField, 'maxSelected.length', 0)) {
                selected.push({
                    field: searchCriteriaField.maxField,
                    items: searchCriteriaField.maxSelected,
                });
            }

            return selected;
        }, []);

        return searchRequest;
    }

    async addSample(candidate) {
        const { positionId } = this.$stateParams;
        const { recruiterId } = this.searchData;
        const { talentID: talentId } = candidate;
        const candidateId = _.get(candidate, 'workflow.candidateId');

        try {
            await this.PositionService.addSample(positionId, talentId, candidateId, recruiterId);

            this.setupCandidateSampleActions(candidate);

            this.$timeout(() => this.NotificationService.success('SAMPLES_ADD_NOTIFICATION'));
        } catch (error) {
            logger.error(error);
            this.$timeout(() => this.NotificationService.error('SAMPLES_ADD_ERROR_NOTIFICATION'));
        }
    }

    async removeSample(candidate) {
        const { positionId } = this.$stateParams;

        try {
            await this.PositionService.removeSample(positionId, candidate.talentID);

            this.setupCandidateSampleActions(candidate);

            this.$timeout(() => this.NotificationService.success('SAMPLES_REMOVE_NOTIFICATION'));
        } catch (error) {
            logger.error(error);
            this.$timeout(() => this.NotificationService.error('SAMPLES_REMOVE_ERROR_NOTIFICATION'));
        }
    }

    async setupCandidateSampleActions(candidate) {
        if (!this.PermissionService.isTalenyaUser()) {
            return;
        }

        const { positionId } = this.$stateParams;
        const isMainSearch = this.searchData.showView === 'MainSearch';
        const isClaimedStatus = this.currentCandidate.workflow.recruiterStatus.current === 'Claimed';
        const isFeedbackTab = this.$stateParams.workflowStep === 'Feedback';
        const isSamplesTab = this.$stateParams.workflowStep === 'Samples';
        const canWorkWithSamples = isMainSearch || isClaimedStatus || isFeedbackTab || isSamplesTab;

        if (!canWorkWithSamples) {
            candidate.canAddSample = false;
            candidate.canRemoveSample = false;

            return;
        }

        try {
            const { canAddSample, canRemoveSample, sample } = await this.PositionService.getSampleActions(positionId, candidate.talentID);

            this.$timeout(() => {
                candidate.canAddSample = canAddSample;
                candidate.sample = sample;
                candidate.canRemoveSample = canRemoveSample;
                if (candidate.sample && !candidate.sample.selected) {
                    candidate.unselectedSample = candidate.sample;
                }
            });
        } catch (error) {
            logger.error(error);
            this.$timeout(() => this.NotificationService.error('SAMPLES_GET_ACTIONS_ERROR_NOTIFICATION'));
        }
    }

    openBulkClaimPopup() {
        const modalInstance = this.$uibModal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            ariaDescribedBy: 'modal-body',
            templateUrl: 'shared/modals/bulkClaimPopup/template.html',
            controller: 'bulkClaimPopupCtrl',
            controllerAs: 'ctrl',
            windowClass: 'bulk-claim',
            backdrop: 'static',
            size: 'md',
            resolve: {
                data: () => ({
                    candidates: this.filteredListOfCandidatesToDisplay,
                    recruiterId: _.get(this, 'searchData.recruiterId'),
                }),
                onSubmit: () => this.onBulkClaim.bind(this),
            },
        });
        modalInstance.result.then(() => {}, () => {});
    }

    async onBulkClaim(candidates) {
        if (!this.canClaim) {
            this.NotificationService.error('CANDIDATE_CLAIM_LIMIT_EXCEED_ERROR_MESSAGE');
            return;
        }

        try {
            const response = await this.searchData.bulkClaimCandidates({ candidates });
            const result = _.get(response, 'result');
            if (result === 'ok') {
                this.NotificationService.success('CANDIDATES_HAVE_BEEN_CLAIMED');
            } else {
                this.NotificationService.error('CANDIDATES_CLAIM_ERROR');
            }
            this.reloadPage();
        } catch (error) {
            logger.error(error);
            this.NotificationService.error('CANDIDATES_CLAIM_ERROR');
        }
    }

    switchTotalSearchCountDropdown(forceClose) {
        if (forceClose) {
            this.showTotalSearchCountDropdown = false;
            return;
        }
        this.showTotalSearchCountDropdown = !this.showTotalSearchCountDropdown;
    }

    switchFromPredictionDropdown(forceClose) {
        if (forceClose) {
            this.showFromPredictionDropdown = false;
            return;
        }
        this.showFromPredictionDropdown = !this.showFromPredictionDropdown;
    }

    switchFromMatchDropdown(forceClose) {
        if (forceClose) {
            this.showFromMatchDropdown = false;
            return;
        }
        this.showFromMatchDropdown = !this.showFromMatchDropdown;
    }

    goToNewSearch() {
        if (this.$state.is('employer.search')) {
            this.$state.go('employer.searchNew', {
                recruiterId: this.searchData.employerId,
                positionId: this.searchData.positionData._id,
                history: 1,
                page: 1,
                talentID: null,
                scroll: 0,
                searchName: null,
            }, { reload: true });
        } else if (this.$state.is('recruiter.search')) {
            this.$state.go('recruiter.searchNew', {
                recruiterId: this.searchData.recruiterId,
                positionId: this.searchData.positionData._id,
                history: 1,
                page: 1,
                talentID: null,
                scroll: 0,
                searchName: null,
            }, { reload: true });
        }
    }

    getCSVWorkflowName() {
        const workflowName = this.getWorkflowName();
        return workflowName === 'MainSearch' ? 'Search Results' : workflowName;
    }
}

export const SearchControllerConfiguration = {
    template,
    bindings: {
        searchData: '=',
        isPositionGdprCompliant: '<',
    },
    controller: SearchController,
    controllerAs: 'searchCtrl',
};

angular.module('TALENYA-FE')
    .component('searchComponent', SearchControllerConfiguration);
